import React, { useContext, useState, useEffect, useRef } from 'react'
import { dataContext, localestr, uid, toText, load, validate_ex_mark, itemToText, getIrgValue } from '../utils.js'
import { GEMI_URL } from '../constants'
import EditCtrl from '../cmp/EditCtrl.js';
import EditIrg from '../cmp/EditIrg.js';
import EditImg from '../cmp/EditImg.js';
import Menu from '../cmp/menu'
import Panel from '../cmp/Panel'
import Info from '../cmp/info.js';
import UniTable from '../cmp/UniTable'
import FldModifiers from './FldModifiers'
import CatModifiers from './CatModifiers'
import icon from '../icons.svg'
import labels from '../labels.svg'
import WndBottling from '../cmp/WndBottling.js';

let timer = null
let loading = false

function CatGoodsEdit({ data, actions }) {
  let wndData = ''
    /*if(data) wndData=data.wndData
    else*/ wndData = actions.getWndData();
  const setWndData = actions.setWndData
  const tabClose = actions.tabClose
  const tabNew = actions.tabNew
  const tblPos = actions.tblPos  //Таблиця
  const isActive = actions.isActive  //Таблиця
  const setGlData = actions.setGlData
  const getGlData = actions.getGlData

  const context = useContext(dataContext)
  const saveData = context.saveData
  const msg = context.msg
  const getSettings = context.getSettings
  const addTWnd = context.addTWnd
  const inputNumber = context.inputNumber
  const loaddata = context.loaddata
  const newTWnd = context.newTWnd
  const new_window = context.new_window

  const selUnitType = context.data['selUnitType']
  const selGoodType = context.data['selGoodType']
  const selectionType = getSettings().selectionType || '0'
  const langs = (context.data['sysConst']['langs'] || []).filter(el => parseInt(el.is_used || 0) === 1)
  const fldGoods = context.data['fldGoods']
  const catDevices = context.data['catDevices']
  const gemi = parseInt(context.data['sysConst']['gemi'] || 0)

  const dragRef = useRef(null);

  const [edit, setEdit] = useState(false)
  const [busy, setBusy] = useState(false)
  const [isActive2, setisActive] = useState(false)

  const generateTranslations = () => {
    if (!langs || langs.length === 0 || langs.every(l => Number(l.is_used) === 0)) {
      msg(localestr('Оберіть мову для перекладу в налаштуванням онлайн меню'), localestr('Помилка'), [{
        caption: 'OK',
        action: () => { }
      }]);
      return;
    }

    const selectedLangs = langs.filter(l => Number(l.is_used) === 1).map(i => i.code)
    let newData = { ...wndData, changed: true };
    if (!wndData.id) {
      let items = [{
        type: 1, data: [{
          id: 0,
          name: wndData?.name ?? '',
          description: wndData?.description || null,
        }], fields: ['name', 'description']
      }];

      if (wndData?.modifiers) {
        const modifiers = Object.values(
          (wndData?.modifiers || []).reduce((acc, item) => {
            if (item.child?.length > 0) {
              acc[5] = acc[5] || { type: 5, data: [], fields: ['name'] };
              acc[5].data.push({ id: item.uid, name: item.name });
              acc[6] = acc[6] || { type: 6, data: [], fields: ['name'] };
              item.child.forEach(child => {
                acc[6].data.push({ id: child.uid, name: child.name });
              });
            } else {
              acc[6] = acc[6] || { type: 6, data: [], fields: ['name'] };
              acc[6].data.push({ id: item.uid, name: item.name });
            }

            return acc;
          }, {})
        );
        items = items.concat(modifiers);
      }
      loaddata(`action=translation&data=${JSON.stringify({ langs: selectedLangs, items, new: true })}`, undefined, (d) => processTranslationData(d, newData));
    } else {
      const modifiers = wndData?.modifiers ?
        Object.values(wndData.modifiers.reduce((acc, item) => {
          if (item.child?.length > 0) {
            acc[5] = acc[5] || { type: 5, ids: [] };
            acc[5].ids.push(parseInt(item.id));
            acc[6] = acc[6] || { type: 6, ids: [] };
            acc[6].ids.push(...item.child.map(child => parseInt(child.id)));
          } else {
            acc[6] = acc[6] || { type: 6, ids: [] };
            acc[6].ids.push(parseInt(item.id));
          }
          return acc;
        }, {})) : [];

      loaddata(`action=translation&data=${JSON.stringify({ langs: selectedLangs, entities: [{ type: 1, ids: [wndData.id] }, ...modifiers] })}`, undefined, (d) => processTranslationData(d, newData));
    }
  };

  const processTranslationData = (responseData, newData) => {
    newData.translations = {
      en: { name: '', description: '', modifiers: {} },
      de: { name: '', description: '', modifiers: {} },
      it: { name: '', description: '', modifiers: {} },
      hu: { name: '', description: '', modifiers: {} }
    };

    if (responseData.data['1']) {
      for (const key in responseData.data['1']) {
        const product = responseData.data['1'][key];
        for (const lang in product) {
          if (newData.translations[lang]) {
            newData.translations[lang].name = product[lang]?.name || '';
            newData.translations[lang].description = product[lang]?.description || '';
          }
        }
      }
    }

    for (const modifierTypeKey in responseData.data) {
      const modifierType = parseInt(modifierTypeKey);
      if (isNaN(modifierType) || modifierType === 1) continue;

      const modifiers = responseData.data[modifierTypeKey];
      for (const modifierId in modifiers) {
        const modifierData = modifiers[modifierId];
        for (const lang in modifierData) {
          if (newData.translations[lang]) {
            newData.translations[lang].modifiers[modifierId] = {
              name: modifierData[lang]?.name || '',
              type: modifierType.toString()
            };
          }
        }
      }
    }

    setWndData(newData, true);
  };

  const aiGoodsContent = async () => {
    let ingredients = ''
    if (wndData.ingr) {
      // Process ingredients data
      const catGoods= context.data['catGoods'] || []
      wndData.ingr.forEach(item => {const ing=catGoods.find(g => g.id === item.good); ingredients += ing?.name + ' ' + item.qtt + ' ' + selUnitType.find(u => u.value === ing?.unit)?.name + ', ' })
    }
    const dishData = { operation: 'menu', dishName: wndData.menu_name || wndData.name, ingredients: ingredients }
    fetch(GEMI_URL, { // Your POST endpoint
      method: 'POST',
      //mode: 'no-cors', //це удалити
      //headers: {'Content-Type': 'application/json' ,'Accept': 'all',},
      credentials: 'include',
      body: JSON.stringify(dishData)
    }).then(
      response => {
        //сonsole.log('Response status:', response.status);
        if (response.status !== 200) {
          msg(localestr('Відсутнє з\'єднання') + ' con' + response.status, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
          return
        }
        response.text().then(d => {
          const result = JSON.parse(d.substring(1))
          if (result.status === 'error') {
            msg(result.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
            return
          }
          let newData = { ...wndData, changed: true }
          newData.description = result.description
          newData.proteins = (result.nutrients.proteins || '').replace(/[^0-9.]/g, "")
          newData.fat = (result.nutrients.fats || '').replace(/[^0-9.]/g, "")
          newData.carbohydrate = (result.nutrients.carbs || '').replace(/[^0-9.]/g, "")
          newData.energy = (result.nutrients.calories || '').replace(/[^0-9.]/g, "")
          newData.allergens = []
          const aler = result.allergens_found || []
          if (aler.findIndex(el => el.toLowerCase().includes('глютен або його сліди')) !== -1) newData.allergens.push('GL')
          if (aler.findIndex(el => el.toLowerCase().includes('лактоза')) !== -1) newData.allergens.push('LAC')
          if (aler.findIndex(el => el.toLowerCase().includes('фруктоза')) !== -1) newData.allergens.push('FRU')
          if (aler.findIndex(el => el.toLowerCase().includes('злакові продукти')) !== -1) newData.allergens.push('W')
          if (aler.findIndex(el => el.toLowerCase().includes('ракоподібні продукти')) !== -1) newData.allergens.push('C')
          if (aler.findIndex(el => el.toLowerCase().includes('яйця')) !== -1) newData.allergens.push('E')
          if (aler.findIndex(el => el.toLowerCase().includes('риба')) !== -1) newData.allergens.push('F')
          if (aler.findIndex(el => el.toLowerCase().includes('арахіс')) !== -1) newData.allergens.push('PN')
          if (aler.findIndex(el => el.toLowerCase().includes('соєві боби')) !== -1) newData.allergens.push('S')
          if (aler.findIndex(el => el.toLowerCase().includes('молочні продукти')) !== -1) newData.allergens.push('M')
          if (aler.findIndex(el => el.toLowerCase().includes('горіхи')) !== -1) newData.allergens.push('N')
          if (aler.findIndex(el => el.toLowerCase().includes('селера')) !== -1) newData.allergens.push('SEL')
          if (aler.findIndex(el => el.toLowerCase().includes('гірчиця')) !== -1) newData.allergens.push('MUS')
          if (aler.findIndex(el => el.toLowerCase().includes('кунжут')) !== -1) newData.allergens.push('SE')
          if (aler.findIndex(el => el.toLowerCase().includes('люпін')) !== -1) newData.allergens.push('L')
          if (aler.findIndex(el => el.toLowerCase().includes('молюски')) !== -1) newData.allergens.push('MO')
          setWndData(newData, true)
          setTimeout(() => {
            msg(localestr('Оновлено алергени, калорії, опис. Для створення картинки відкрийте ваш улюблений ШІ, перемкніть його на створення зображень і вставте наступний текст') + "\n\n" + result.visual_concept, localestr('Інформація'), [{ caption: 'OK', action: () => { } }])
          }, 500)
          //console.log(result)
        })
      }
    ).catch(err => msg(localestr('Відсутнє з\'єднання') + ' err' + err, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]))

  }


  const setValue = (name, data) => {
    if (name === 'type') {
      if (parseFloat(wndData.sum_bal) || 0) {
        if ((parseInt(wndData.type) === 1 && parseInt(data) === 0) || (parseInt(wndData.type) === 0 && parseInt(data) === 1)) { } //Нічого не робимо, можна міняти
        else {
          msg(localestr('Увага! Ви змінюєте вид товару, який є у залишках!'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
          //return
        }
      }
    }
    let newData = { ...wndData, changed: true }
    //if(name==='bottling') name='koef'
    if (name === 'sum_up') {
      let val = parseFloat(wndData.sum_in_mod || wndData.sum_in || ttl_cost || 0)
      if (!val) return
      if (!parseFloat(data)) return
      if (wndData.koef && parseFloat(wndData.koef)) val = val * parseFloat(wndData.koef)
      val = val * (100 + parseFloat(data)) / 100
      const now = new Date()
      now.setUTCHours(0, 0, 0, 0)
      const currDate = now.toISOString().split('.')[0] + 'Z'
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => setRegisterOut('set', currDate, val.toFixed(2)), 900)
      newData['sum_up_mod'] = data
      setWndData(newData, true)
      return
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (name === 'name' && parseInt(wndData.is_menu)) {
      if (!newData.menu_name) newData.menu_name = data
      else if (wndData.menu_name === wndData.name) newData.menu_name = data
    }
    if (name === 'is_menu' && parseInt(data)) if (!newData.menu_name) newData.menu_name = newData.name
    if (name === 'fiscal' && data.device) if (parseInt(data.device.value) < 4) { msg(localestr('Недопустимий тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (name === 'bottling' && data === '1') {
      let is_liter = false
      if (wndData.unit && (wndData.unit === '3' || wndData.unit.value === '3')) is_liter = true
      let cont = <WndBottling action={d => setValue('koef', d)} is_liter={is_liter} />
      newTWnd(cont, localestr('Розлив з пляшки'))
    }
    if (name === 'koef' && data) newData.bottling = '1'
    setWndData(newData, true)
  }

  const setTranslationValue = (name, code, data) => {
    let newData = { ...wndData, changed: true }
    let translations = wndData?.translations || {}
    if (!translations[code]) translations[code] = { name: "", description: "", modifiers: {}, type: 1 }
    if (data === '') translations[code][name] = null
    else if (name === 'modifiers') {
      const mod_translate = { ...(translations[code].modifiers || {}) }

      mod_translate[data.id] = data.data
      translations[code][name] = mod_translate;
    }
    else translations[code][name] = data
    newData['translations'] = translations
    setWndData(newData, true)
  }


  const setAllerg = (name, data) => {
    let newData = { ...wndData, changed: true }
    let allergens = [...newData.allergens]
    if (!parseInt(data)) allergens = allergens.filter(el => el !== name)
    else if (!allergens.includes(name)) allergens.push(name)
    newData.allergens = allergens
    setWndData(newData, true)
  }

  const setRegisterIn = (act, date, val, olddate) => {
    let newData = { ...wndData }
    let data = []
    let found = false
    if (newData) data = newData.register_in
    if (!data) data = []
    if (act === 'set') {
      const idx = data.findIndex(el => el.date === date)
      if (idx !== -1) {
        data[idx].act = act
        data[idx].value = val
      }
      else data.push({ act, date, value: val, olddate })
    } else if (act === 'del') {
      const idx = data.findIndex(el => el.date === date)
      if (idx !== -1) {
        if (olddate) data[idx].act = act
        else data.splice(idx, 1)
      }
      else data.push({ act, date, value: val, olddate })
    } else if (act === 'mod') {
      if (val === 'T00:00:00Z') return
      data.forEach(el => {
        if (el.date === date) {
          found = true
          el.date = val
        }
      })
      if (!found) {
        data.push({ act, date: val, value: undefined, olddate })
      }
    }
    newData.register_in = data
    newData.sum_up_mod = null
    newData.sum_in_mod = getIrgValue(new Date(), data)
    setWndData(newData)
  }

  const setRegisterOut = (act, date, val, olddate) => {
    let newData = { ...wndData }
    let data = []
    let found = false
    if (newData) data = newData.register_out
    if (!data) data = []
    if (act === 'set') {
      const idx = data.findIndex(el => el.date === date)
      if (idx !== -1) {
        data[idx].act = act
        data[idx].value = val
      }
      else data.push({ act, date, value: val, olddate })
    } else if (act === 'del') {
      const idx = data.findIndex(el => el.date === date)
      if (idx !== -1) {
        if (olddate) data[idx].act = act
        else data.splice(idx, 1)
      }
      else data.push({ act, date, value: val, olddate })
    } else if (act === 'mod') {
      if (val === 'T00:00:00Z') return
      data.forEach(el => {
        if (el.date === date) {
          found = true
          el.date = val
        }
      })
      if (!found) {
        data.push({ act, date: val, value: undefined, olddate })
      }
    }
    newData.register_out = data
    newData.sum_up_mod = null
    newData.sum_out_mod = getIrgValue(new Date(), data)
    setWndData(newData)
  }

  const update = (d) => {
    //console.log('update')
    //return
    if (!d) return
    if (!d.data) return
    delete d.data.big_img
    delete d.data.small_img
    let newData = { ...wndData, ...d.data, changed: false }
    //console.log(newData)
    //console.log({...data.wndData})
    setWndData(newData, false)
  }

  const saveRegisterIn = (d, close = false) => {
    if (wndData.register_in) {
      if (!d.data) { saveRegisterOut(d, close); return }
      if (!d.data.id) { saveRegisterOut(d, close); return }
      if (!wndData.register_in.length) { saveRegisterOut(d, close); return }
      if (wndData.register_in.length === 1) {
        let newData = { status: 'set', key: 'Goods', data: { id: d.data.id, updcat: 'catGoods', updkey: 'sum_in' } }
        if (wndData.register_in[0].date) newData.data.date = wndData.register_in[0].date.substring(0, 10)
        if (wndData.register_in[0].olddate) newData.data.olddate = wndData.register_in[0].olddate.substring(0, 10)
        if (wndData.register_in[0].value) newData.data.value = wndData.register_in[0].value
        if (wndData.register_in[0].act === 'del') newData.status = 'del'
        saveData(newData, d => saveRegisterOut(d, close))
      }
      else {
        let newData = {
          status: 'rgo', key: 'Goods', data: {
            id: d.data.id, updcat: 'catGoods', updkey: 'sum_in',
            grp: wndData.register_in.map(el => { if (el.olddate) return ({ ...el, date: el.date.substring(0, 10), olddate: el.olddate.substring(0, 10) }); else return ({ ...el, date: el.date.substring(0, 10) }) })
          }
        }
        saveData(newData, () => saveRegisterOut(d, close))
      }

    }
    else saveRegisterOut(d, close)
  }

  const saveRegisterOut = (d, close = false) => {
    if (wndData.register_out) {
      if (!d.data) { if (wndData.update) wndData.update(d.data); saveDoc(null, close); return }
      if (d.data.length) { if (wndData.update) wndData.update(d.data); saveDoc(null, close); return }
      if (!d.data.id) { if (wndData.update) wndData.update(d.data); saveDoc(null, close); return }

      if (wndData.register_out.length === 1) {
        let newData = { status: 'set', key: 'Menu', data: { id: d.data.id, updcat: 'catGoods', updkey: 'sum_out' } }
        if (wndData.register_out[0].date) newData.data.date = wndData.register_out[0].date.substring(0, 10)
        if (wndData.register_out[0].olddate) newData.data.olddate = wndData.register_out[0].olddate.substring(0, 10)
        if (wndData.register_out[0].value) newData.data.value = wndData.register_out[0].value
        if (wndData.register_out[0].act === 'del') newData.status = 'del'
        saveData(newData, () => { if (wndData.update) wndData.update(d.data); saveDoc(null, close) })
      }
      else {
        let newData = {
          status: 'rgo', key: 'Menu', data: {
            id: d.data.id, updcat: 'catGoods', updkey: 'sum_out',
            grp: wndData.register_out.map(el => { if (el.olddate) return ({ ...el, date: el.date.substring(0, 10), olddate: el.olddate.substring(0, 10) }); else return ({ ...el, date: el.date.substring(0, 10) }) })
          }
        }
        saveData(newData, () => { if (wndData.update) wndData.update(d.data); saveDoc(null, close) })
      }

    }
    else { if (wndData.update) wndData.update(d.data); saveDoc(null, close) }
  }

  const saveValue = (close = false) => {
    let errmsg = ''
    const name = (wndData.name || '').substring(0, 100)
    const parent = wndData.parent || { id: null, name: null }
    const type = wndData.type || null
    const without_production = wndData.without_production || null
    const unit = (wndData.unit && wndData.unit.value ? '' + (wndData.unit.value || 0) : '' + (wndData.unit || 0))
    const is_menu = parseInt(wndData.is_menu) || 0
    const menu_name = (wndData.menu_name || '').substring(0, 100)
    //const from=wndData.from || {id:null,name:null}
    let koef = wndData.koef || 0
    if (wndData.bottling === '0') koef = 0
    const department = wndData.department || { id: null }
    const fiscal = wndData.fiscal ? { id: wndData.fiscal.id } : { id: null }
    const excise = wndData.excise && wndData.excise.value ? '' + (wndData.excise.value || '0') : '' + (wndData.excise || '0')
    const no_vat = parseInt(wndData.no_vat) || 0
    const uktz = (wndData.uktz || '').substring(0, 12)
    const gravimetric = wndData.gravimetric || null
    const small_img = (wndData.small_img || '').replace(/\+/g, ' ')
    const guest_enable = wndData.guest_enable || '0'
    const online_enable = wndData.online_enable || '0'
    const disable_discount = wndData.disable_discount || '0'
    const description = wndData.description || ''
    const big_img = (wndData.big_img || '').replace(/\+/g, ' ')
    const menu_cat = wndData.menu_cat || { id: null }
    const sorting = wndData.sort || null
    const colour = wndData.colour ? wndData.colour.src : null
    const barcode = wndData.barcode || null
    const department2 = wndData.department2 || null
    const modifiers = wndData.modifiers || null
    const weight = (wndData.weight || '').substring(0, 15)
    const special_price = (wndData.special_price || '')
    const proteins = (wndData.proteins || '').substring(0, 8)
    const fat = (wndData.fat || '').substring(0, 8)
    const carbohydrate = (wndData.carbohydrate || '').substring(0, 8)
    const energy = (wndData.energy || '').substring(0, 8)
    const allergens = (wndData.allergens || []).toString().substring(0, 50)
    const translations = { ...wndData?.translations } || {};
    const label = wndData.label || null
    const package_ = wndData.package || null

    if (name === null || name === '') errmsg = localestr("Не заповнено ім'я")
    if (type === null || type === '') errmsg = errmsg + ' ' + localestr("Не заповнено вид")
    if (is_menu && department.id === null) errmsg = errmsg + ' ' + localestr("Не заповнено місце приготування")
    if (fiscal.id && fiscal.id !== null) if (parseInt(fiscal.device) <= 3) errmsg = errmsg + ' ' + (localestr('Недопустимий тип пристрою "Фіскальний апарат"'))
    if (parseInt(excise) && uktz === '') errmsg = errmsg + ' ' + (localestr('Не заповнено "Код УКТЗЕД"'))
    if (parseInt(excise) && uktz.length < 10) errmsg = errmsg + ' ' + (localestr('Не правильний "Код УКТЗЕД", має бути 10 цифр'))
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      let id = wndData.id
      if (id === null || id === '' || id === undefined) {
        //let newData={status:'add',key:'CatDiscounts',data:{name:name,pass:pass1,org:org,role:role}}
        let newData = { status: 'add', key: 'CatGoods', data: { name, parent, type, without_production, unit, is_menu, menu_name, koef, department, excise, uktz, fiscal, gravimetric, small_img, guest_enable, online_enable, disable_discount, description, big_img, menu_cat, sorting, colour, barcode, modifiers, no_vat, department2, weight, special_price, proteins, fat, carbohydrate, energy, allergens, translations, label, package: package_ } }

        saveData(newData, d => { saveRegisterIn(d, close); update(d) })
        //почекати ы закрити выкно
      }
      else if (wndData.changed) {
        let newData = { status: 'mod', key: 'CatGoods', data: { id, name, parent, type, without_production, unit, is_menu, menu_name, koef, department, excise, uktz, fiscal, gravimetric, small_img, guest_enable, online_enable, disable_discount, description, big_img, menu_cat, sorting, colour, barcode, modifiers, no_vat, department2, weight, special_price, proteins, fat, carbohydrate, energy, allergens, translations, label, package: package_ } }

        saveData(newData, d => { saveRegisterIn(d, close); update(d) })
      }
      else saveRegisterIn({ data: { id, name, parent, type, without_production, unit, is_menu, menu_name, koef, department, excise, uktz, fiscal, gravimetric, small_img, guest_enable, online_enable, disable_discount, description, big_img, menu_cat, sorting, colour, barcode, modifiers, no_vat, department2, weight, special_price, proteins, fat, carbohydrate, energy, allergens, translations, label, package: package_ } }, close)
    }
  }

  const loadCalculations = (d, curr_id) => {
    setBusy(false)
    const status = d.status
    if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    const calc_list = [...d.data]
    let curr_calc = null
    const curr_date = (new Date()).toISOString()
    if (!wndData.curr_calc && !curr_id) {
      for (let i = 0; i < calc_list.length; i++) {
        if (parseInt(calc_list[i].posted || 0) && calc_list[i].date < curr_date) curr_calc = { ...calc_list[i] }
      }
    } else if (!wndData.curr_calc) {
      for (let i = 0; i < calc_list.length; i++) {
        if (calc_list[i].id === curr_id) {
          curr_calc = { ...calc_list[i] }
          break
        }
      }
    } else if (!wndData.curr_calc.id) {
      for (let i = 0; i < calc_list.length; i++) {
        if (calc_list[i].id === curr_id) {
          curr_calc = { ...calc_list[i] }
          break
        }
      }
    } else {
      for (let i = 0; i < calc_list.length; i++) {
        if (calc_list[i].id === wndData.curr_calc.id) {
          curr_calc = { ...calc_list[i] }
          break
        }
      }
    }
    if (curr_calc) {
      //доповнити цінами і uid
      const catGoods = context.getData('catGoods')
      for (let i = 0; i < curr_calc.table.length; i++) {
        const good_id = curr_calc.table[i].good_id
        const idx = (catGoods || []).findIndex((it) => it.id === good_id)
        curr_calc.table[i].uid = uid()
        if (idx !== -1) curr_calc.table[i].sum_prc = parseFloat(catGoods[idx].sum_in || 0)
        if (curr_calc.table[i].ingr) {
          curr_calc.table[i].sum_prc = 0
          for (let j = 0; j < curr_calc.table[i].ingr.length; j++) {
            if (curr_calc.table[i].ingr[j].type > 1) continue
            const good_id = curr_calc.table[i].ingr[j].good
            const idx = (catGoods || []).findIndex((it) => it.id === good_id)
            if (idx !== -1) curr_calc.table[i].sum_prc += parseFloat(catGoods[idx].sum_in || 0) * parseFloat(curr_calc.table[i].ingr[j].qtt || 0)
          }

        }

      }
      curr_calc.list = []
      if (curr_calc.table) curr_calc.list = curr_calc.table.map((item) => {
        const newItem = {
          uid: uid(),
          id: item.id,
          good: { id: item.good_id, name: item.good, parent: { id: item.good_pid }, obj_type: 'catGoods' },
          type: selGoodType.find(x => parseInt(x.value) === parseInt(item.type)),
          unit: selUnitType.find(x => x.value === item.unit),
          sum_qtt: item.qtt.toFixed(4),
          sum_netto: item.netto.toFixed(0),
          ingr: item.ingr,
          sum_prc: item.sum_prc
        }
        if (item.edit) newItem.edit = true
        return newItem
      })
    }
    setWndData({ ...wndData, calc_list, curr_calc })
  }

  const loadData = (d) => {
    if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      wndData = actions.getWndData()
      const newData = { ...wndData, excise_marks: d.data }
      //setWndData({...wndData,list:undefined,excise_marks:d.data})
      setWndData(newData)
      setTimeout(() => {
        if (wndData.sorting) sortList(wndData.sorting.dataId, wndData.sorting.sort, undefined)
        else sortList('name', 'asc', undefined)
      }, 50)
    } else {
      load('action=getExciseMark&data=' + JSON.stringify({ id: wndData.id }), (dt) => { loadData(dt) })
    }
  }

  const tick = () => {
    if (edit) return
    loadData()
  }

  // eslint-disable-next-line
  useEffect(() => {
    if (context.data['catGoods'] === undefined) {
      context.getData('catGoods')
    }
    if (context.data['sysConst'] === undefined) {
      context.getData('sysConst')
    }
    if (wndData.calc_list === undefined && wndData.id && (wndData.type === '2' || wndData.type === '3')) {
      if (!busy) {
        setBusy(true)
        load('action=lstCalculatios&data=' + wndData.id, loadCalculations)
      }
    }
    if (context.data['sysConst'] && wndData.id) {
      let consts = context.data.sysConst
      if (wndData.type === '0' && parseInt(consts.constExciseMark || 0)) {
        if (!wndData.excise_marks) tick()
        const intervalHandle = setInterval(tick, 30000)
        return () => clearInterval(intervalHandle)
      }
    }
  },)

  const listFromData = (currentCol, setCurrCol) => {
    wndData = actions.getWndData()
    let list = []
    if (wndData.excise_marks) list = wndData.excise_marks.map((item) => {
      const newItem = {
        uid: uid(),
        id: item.id,
        code: item.code,
        sum_qtt: (parseFloat(item.qtt || 0) / 100).toFixed(2),
        sum_vol: (parseFloat(item.vol || 0) / 1000),
        fiscal: item.fiscal
      }
      if (item.edit) newItem.edit = true
      if (currentCol && currentCol.id === item.id) setCurrCol(newItem)
      return newItem
    })
    return list
  }

  const sortList = (col, sort, list) => {
    if (edit) return
    let needUpd = false
    let currentCol = wndData.currentCol
    if (!list) { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (!wndData.list) { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else list = wndData.list.slice()

    list.sort((a, b) => {
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col === 'sum') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = vala.toLowerCase()
        valb = valb.toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting.dataId !== col || wndData.sorting.sort !== sort) setWndData({ ...wndData, list, sorting, currentCol })
  }

  const setColEx = (currentCol) => {
    setisActive(true)
    if (edit) return
    if (wndData.currentCol) if (currentCol.uid === wndData.currentCol.uid) return
    //const list=wndData.list
    //const sorting=wndData.sorting
    setWndData({ ...wndData, currentCol })
  }

  const setShowHideEx = () => {
    if (!wndData.show_old_marks) setWndData({ ...wndData, show_old_marks: true })
    else setWndData({ ...wndData, show_old_marks: false })
  }

  const newItemEx = () => {
    if (edit) return
    setisActive(true)
    let currentCol = { id: '', uid: uid() }
    const list = wndData.list.concat(currentCol)
    setWndData({ ...wndData, list, currentCol })
    setEdit(true)
  }

  const editItemEx = () => {
    if (edit) return
    if (!wndData.currentCol) return
    const currentCol = { ...wndData.currentCol }
    //currentCol.cancel={...wndData.currentCol}
    setWndData({ ...wndData, currentCol })
    setEdit(true)
  }

  const editClickEx = () => {
    if (typeof wndData.currentCol === 'object') editItemEx()
  }

  const cancelEditEx = () => {
    setEdit(false)
    if (!wndData.currentCol.code && !wndData.currentCol.qtt) {
      const list = wndData.list.filter(el => el.uid !== wndData.currentCol.uid)
      setWndData({ ...wndData, list, currentCol: undefined })
    }
    setTimeout(() => sortList(wndData.sorting.dataId, wndData.sorting.sort, wndData.list), 25)
  }

  const removeItemEx = (d) => {
    if (edit) return
    wndData = actions.getWndData()
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol }
    const list = wndData.list
    const excise_marks = wndData.excise_marks
    if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      const idx = list.findIndex(el => el.id === currCol.id)
      if (idx !== -1) list.splice(idx, 1)
      const idx2 = excise_marks.findIndex(el => el.id === currCol.id)
      if (idx2 !== -1) excise_marks.splice(idx2, 1)
      let currentCol = undefined
      let curIdx = idx
      if (curIdx >= list.length) curIdx = list.length - 1
      if (curIdx !== -1) currentCol = { ...list[curIdx] }
      let newData = { ...wndData, list, excise_marks, currentCol }
      setWndData(newData)
    }
    else {
      const data = { code: currCol.code, id: currCol.id }
      load('action=delExciseMark&data=' + JSON.stringify(data), (dt) => { removeItemEx(dt) })
    }
  }

  const showUsage = (d) => {
    if (edit) return
    wndData = actions.getWndData()
    if (!wndData.currentCol) return
    //tabNew('repExciseUsage',localestr('Використання марок'),{})
    if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      let cont_lst = localestr('Немає даних')
      let cont = null
      const stl1 = { display: 'inline-block' }
      const stl2 = { display: 'inline-block', minWidth: '65px', textAlign: 'right' }
      const stl3 = { display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between' }
      if (d.data) {
        cont_lst = d.data.map(el => {
          if (el.fiscal) return <div style={stl3} className='link' key={'i' + el.id} onClick={() => new_window(el)}><div style={stl1}>{itemToText(el)}</div><div style={stl2}>{(el.qtt / 100).toFixed(2) + '%'}</div></div>
          else return <div style={{ ...stl3, color: 'GrayText' }} className='link' key={'i' + el.id} onClick={() => new_window(el)}><div style={stl1}>{itemToText(el)}</div><div style={stl2}>{(el.qtt / 100).toFixed(2) + '%'}</div></div>
        })
        if (!cont_lst.length) cont_lst = localestr('Немає даних')
      }
      cont = <div><div style={{ fontWeight: 'bold' }}>{localestr('Використання акцизної марки ') + ' ' + d.mark}</div><div>{cont_lst}</div></div>
      const btn = [{ caption: 'OK', action: () => { } },
      {
        caption: localestr('Пошук в ДФС'), action: () => {
          const a = document.createElement('a')
          a.href = 'https://cabinet.tax.gov.ua/registers/mark/' + d.mark
          a.target = '_blank'
          a.click()
        }
      }]

      msg(cont, localestr('Інформація'), btn)
    } else {
      load('action=usgExciseMark&data=' + wndData.currentCol.code, showUsage)
    }

  }

  const saveValueTbl = (d) => {
    let errmsg = ''
    wndData = actions.getWndData()
    const currCol = { ...wndData.currentCol }
    const list = wndData.list
    const excise_marks = wndData.excise_marks
    if (!currCol) return
    if (!wndData.id) errmsg = localestr("Товар ще не збережений!")
    if (!currCol.code) errmsg = localestr("Не заповнено серію, номер акцизної марки")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      if (d) {
        const status = d.status
        if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
        if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
        currCol.sum_qtt = parseFloat(currCol.sum_qtt || 0).toFixed(2)
        currCol.id = d.data.id
        const idx = list.findIndex(el => el.uid === currCol.uid)
        if (idx === -1) list.push(currCol)
        else list[idx] = currCol
        const idx2 = excise_marks.findIndex(el => el.id === d.data.id)
        if (idx2 === -1) excise_marks.push(d.data)
        else excise_marks[idx2] = d.data
        let newData = { ...wndData, list, excise_marks, currentCol: currCol }
        setWndData(newData)
        setEdit(false)
        setisActive(false)
      }
      else {
        const data = { good: wndData.id, uid: currCol.uid, code: currCol.code, qtt: parseInt(parseFloat(currCol.sum_qtt || 0) * 100), fiscal: currCol.fiscal }

        if (currCol.sum_vol) data.vol = currCol.sum_vol * 1000
        if (currCol.id) data.id = currCol.id
        load('action=setExciseMark&data=' + JSON.stringify(data), (dt) => { saveValueTbl(dt) })
      }

    }
  }

  const setValEx = (name, data) => {
    let currentCol = wndData.currentCol
    setisActive(false)
    if (name === 'qtt' && parseFloat(data) > 100) currentCol[name] = 100
    else if (name === 'code') currentCol[name] = validate_ex_mark(data)
    else if (name === 'fiscal' && data.device && parseInt(data.device.value) < 4) { msg(localestr('Недопустимий тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    else currentCol[name] = data
    let newData = { ...wndData, currentCol }
    setWndData(newData)
  }


  const anyKeyEx = (key) => {
    if (key === 'Delete') removeItemEx()
    else if (key === 'Insert') newItemEx()
    else if (key === 'Escape') cancelEditEx()
    else if (key === 'shift_F4') tabClose()
  }

  let excise_block = null
  if (context.data['sysConst'] && wndData.id) {
    let consts = context.data.sysConst
    if (wndData.type === '0' && parseInt(consts.constExciseMark || 0)) {
      const cols = [
        { caption: 'icon', minWidth: '20', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: () => { saveValueTbl() } },
        { caption: localestr('Серія, номер'), minWidth: '100', dataId: 'code', sortable: true, typeVal: 'text', setFn: (d) => { setValEx('code', d) } },
      ]
      if (wndData.unit && (wndData.unit.value === '3' || wndData.unit === '3')) cols.push({ caption: localestr('Об\'єм, л'), minWidth: '130', maxWidth: '135', dataId: 'sum_vol', sortable: true, typeVal: 'number', setFn: (d) => { setValEx('sum_vol', d) } })
      cols.push({ caption: localestr('Використано, %'), minWidth: '130', maxWidth: '135', dataId: 'sum_qtt', sortable: true, typeVal: 'number2', setFn: (d) => { setValEx('sum_qtt', d) } })
      cols.push({ caption: localestr('ПРРО'), minWidth: '100', dataId: 'fiscal', sortable: true, typeVal: 'catDevices', setFn: (d) => { setValEx('fiscal', d) } })
      const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
      let wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
      let tool_item = <div tabIndex='0' className='toolBarItem' title={localestr('Показати всі марки')}
        onClick={() => setShowHideEx()}
        onKeyUp={(e) => { if (e.key === 'Enter') setShowHideEx() }}><img src={icon + '#checkBut'} alt={localestr('Показати всі марки')} /></div>
      if (!wndData.show_old_marks) wndDataList = wndDataList.filter(el => parseFloat(el.sum_qtt || 0) < 97)
      else tool_item = <div tabIndex='0' className='toolBarItem' title={localestr('Сховати використані марки')}
        onClick={() => setShowHideEx()}
        onKeyUp={(e) => { if (e.key === 'Enter') setShowHideEx() }}><img src={icon + '#unchckBut'} alt={localestr('Сховати використані марки')} /></div>
      const min_height = (wndDataList.length > 10 ? 11 : wndDataList.length + 1) * 26 + 7
      excise_block = (<Panel caption={localestr('Акцизні марки')} width={580} open={wndData.p_excise === undefined ? true : wndData.p_excise} setOpen={d => setWndData({ ...wndData, p_excise: d })}>
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
            onClick={() => newItemEx()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItemEx() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
            onClick={() => removeItemEx()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItemEx() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>
          {tool_item}
          <div tabIndex='0' className='toolBarItem' title={localestr('Інформація про використання')}
            onClick={() => showUsage()}
            onKeyUp={(e) => { if (e.key === 'Enter') showUsage() }}><img src={icon + '#info'} alt={localestr('Інформація про використання')} /></div>
        </div>
        <div style={{ margin: '0', height: 'calc(100% - 30px)', minHeight: min_height + 'px' }}>
          <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit }} sorting={sorting} filter={[]} clickSort={sortList} clickHandle={(item) => { setColEx(item) }} openHandle={editClickEx} keyHandle={anyKeyEx} saveHandle={saveValueTbl} cancelHandle={cancelEditEx} isActive={isActive2 && isActive()} />
        </div>
      </Panel>)
    }
  }

  let bottling = parseFloat(wndData.koef || 0) ? '1' : '0'
  if (wndData.bottling) bottling = wndData.bottling
  let fromCont = <EditCtrl Capt={localestr('Відпускати на розлив')}
    title={localestr('Дає змогу задати об\'єм одної порції при продажу без створення калькуляції. Робіть прихід літрами, а продавайте порціями!')}
    Value={bottling} typeVal={'l_check'} setVal={(d) => { setValue('bottling', d) }} width1='270' width2='20' />
  if (bottling === '1') {
    let unt = wndData.unit
    if (typeof unt !== 'object') unt = selUnitType.find(el => el.value === unt)
    fromCont =
      <div style={{ margin: '2px 0', display: 'inherit', alignItems: 'end' }}>
        <EditCtrl Capt={localestr('Розливати')}
          title={localestr('Дає змогу задати об\'єм одної порції при продажу без створення калькуляції. Робіть прихід літрами, а продавайте порціями!')}
          Value={bottling} typeVal={'l_check'} setVal={(d) => { setValue('bottling', d) }} width1='80' width2='20' />
        <Info info={<table style={{ border: '1px solid', borderCollapse: 'collapse', textAlign: 'center' }}><caption>{localestr('Таблиця дозувань напоїв на одну порцію залежно від об\'єму пляшки')}</caption>
          <thead><tr><th style={{ border: '1px solid' }}>{localestr('порція\\пляшка')}</th><th style={{ border: '1px solid' }}>{'0.5' + localestr('л')}</th><th style={{ border: '1px solid' }}>{'0.7' + localestr('л')}</th><th style={{ border: '1px solid' }}>{'0.75' + localestr('л')}</th><th style={{ border: '1px solid' }}>{'1.0' + localestr('л')}</th></tr></thead>
          <tbody><tr><td style={{ border: '1px solid' }}>{'50' + localestr('мл')}</td><td style={{ border: '1px solid' }}>0.1</td><td style={{ border: '1px solid' }}>0.0714</td><td style={{ border: '1px solid' }}>0.0667</td><td style={{ border: '1px solid' }}>0.05</td></tr>
            <tr><td style={{ border: '1px solid' }}>{'100' + localestr('мл')}</td><td style={{ border: '1px solid' }}>0.2</td><td style={{ border: '1px solid' }}>0.1429</td><td style={{ border: '1px solid' }}>0.1333</td><td style={{ border: '1px solid' }}>0.1</td></tr>
            <tr><td style={{ border: '1px solid' }}>{'150' + localestr('мл')}</td><td style={{ border: '1px solid' }}>0.3</td><td style={{ border: '1px solid' }}>0.2143</td><td style={{ border: '1px solid' }}>0.2</td><td style={{ border: '1px solid' }}>0.15</td></tr>
            <tr><td style={{ border: '1px solid' }}>{'200' + localestr('мл')}</td><td style={{ border: '1px solid' }}>0.4</td><td style={{ border: '1px solid' }}>0.2857</td><td style={{ border: '1px solid' }}>0.2667</td><td style={{ border: '1px solid' }}>0.2</td></tr>
            <tr><td style={{ border: '1px solid' }}>{'250' + localestr('мл')}</td><td style={{ border: '1px solid' }}>0.5</td><td style={{ border: '1px solid' }}>0.3572</td><td style={{ border: '1px solid' }}>0.3334</td><td style={{ border: '1px solid' }}>0.25</td></tr>
            <tr><td colSpan={5} style={{ border: '1px solid' }}><div style={{ marginTop: '5px' }}>{localestr('Немає необхідного дозування?')}</div>
              <div style={{ maxWidth: '300px' }}>{localestr('Знайдіть його самостійно, розділивши об\'єм одної порції на об\'єм пляшки з якої здійснюється розлив.')}</div>
            </td></tr></tbody>
        </table>} />
        <EditCtrl Capt={'\xa0' + ((unt || { name: '' }).name) + ' ' + localestr('на порцію')} Value={wndData.koef || 0} typeVal={'l_number'} setVal={(d) => { setValue('koef', d) }} width1='164' width2='55' />
      </div>
    if (unt && unt.value === '3') fromCont =
      <div style={{ margin: '2px 0', display: 'inherit', alignItems: 'end' }}>
        <EditCtrl Capt={localestr('Розливати')} Value={bottling} typeVal={'l_check'} setVal={(d) => { setValue('bottling', d) }} width1='80' width2='20' />
        <EditCtrl Capt={'\xa0' + ((unt || { name: '' }).name) + ' ' + localestr('на порцію')} Value={wndData.koef || 0} typeVal={'l_number'} setVal={(d) => { setValue('koef', d) }} width1='164' width2='55' />
      </div>
  }

  let guest_cont = ''
  const empty_img = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

  const [activeTab, setActiveTab] = useState(langs.find(l => l.code !== 'uk')?.code || '');
  if ((wndData.guest_enable && parseInt(wndData.guest_enable)) || (wndData.online_enable && parseInt(wndData.online_enable))) {
    let langs_cont = ''
    let modifiers_cont = ''

    if (wndData?.modifiers?.length > 0) {
      modifiers_cont = <Panel caption={localestr('Переклади модифікаторів')} width={window.innerWidth < 768 ? 250 : 792} open={wndData.p_lang_modifiers === undefined ? false : wndData.p_lang_modifiers} setOpen={d => setWndData({ ...wndData, p_lang_modifiers: d })}>
        <div style={{ marginTop: "3px", maxWidth: '992px', flexGrow: 492 }}>
          {wndData.modifiers.map(item => {
            if (item.type === 0) {
              return <div key={item.id ?? item.uid} style={{}}>
                <div style={{ padding: "2px" }}><EditCtrl Capt={localestr(item.name)} Value={wndData?.translations?.[activeTab]?.modifiers?.[item.id ?? item.uid]?.name || ""}
                  typeVal={'text'} setVal={(d) => { setTranslationValue('modifiers', activeTab, { id: item.id ?? item.uid, data: { type: 5, name: d } }) }} width1='250' width2={window.innerWidth < 768 ? 150 : 450} /></div>
                {item.child ? item.child.map((item2) => (
                  <div key={item2.id ?? item2.uid} style={{ padding: "2px" }}>
                    <EditCtrl Capt={localestr(item2.name)} Value={wndData?.translations?.[activeTab]?.modifiers?.[item2.id ?? item2.uid]?.name || ""}
                      typeVal={'text'} setVal={(d) => { setTranslationValue('modifiers', activeTab, { id: item2.id ?? item2.uid, data: { type: 6, name: d } }) }} width1='250' width2={window.innerWidth < 768 ? 150 : 450} /></div>))
                  : <div>(пусто)</div>}
              </div>
            }
            return <div key={item.id ?? item.uid} style={{ padding: "2px" }}>
              <EditCtrl Capt={localestr(item.name)} Value={wndData?.translations?.[activeTab]?.modifiers?.[item.id ?? item.uid]?.name || ""}
                typeVal={'text'} setVal={(d) => { setTranslationValue('modifiers', activeTab, { id: item.id ?? item.uid, data: { type: 6, name: d } }) }} width1='250' width2={window.innerWidth < 768 ? 150 : 450} />
            </div>;
          })}
        </div>
      </Panel>
    }

    if (langs.length > 0) {
      let fld_goods_mod_btn = null;
      const good_parent = fldGoods.filter((item) => item.id === wndData?.parent?.id);
      if (good_parent[0]?.modifiers)
        fld_goods_mod_btn = <div className='no-print' style={{ margin: '0', minWidth: '337px', display: 'flex', justifyContent: 'center', flexGrow: '100000' }}>
          <div style={{ margin: '2px 0', display: 'inherit', textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}
            onClick={() => { tabNew('fldGoods_edit', localestr('Папка') + ' ' + toText(good_parent[0]['name']), { ...good_parent[0] }) }}>
            {localestr('Не забудьте зробити переклад модифікаторів батьківської папки')}</div>
        </div>
      langs_cont = <Panel caption={localestr('Переклади')} width={window.innerWidth < 768 ? 250 : 792} open={wndData.p_lang === undefined ? false : wndData.p_lang} setOpen={d => setWndData({ ...wndData, p_lang: d })}>
        <div style={{ display: 'flex', gap: '2px' }}>
          {langs.map(item => item.code !== 'uk' ? (
            <button key={item.code} onClick={() => setActiveTab(item.code)}
              className={`tabbuton ${activeTab === item.code && "active"}`}
              style={{ maxWidth: "150px", padding: "0px" }}>{item.name}</button>
          ) : null
          )}
        </div>
        {langs.map(item =>
          item.code !== 'uk' && item.code === activeTab ? (
            <div key={item.id} style={{ margin: '2px 0', display: 'inherit' }}>
              <div style={{ margin: '0', display: 'inherit', flexDirection: 'column', width: `${window.innerWidth < 768 ? '250px' : '492px'}`, maxWidth: '1300px', flexGrow: 492 }}>
                <EditCtrl Capt={localestr('Назва меню')} title={localestr('Назва яка відображаіться офіціанту, гостю, друкується в чеку')}
                  Value={wndData?.translations?.[item.code]?.name || ""} typeVal={'text'} setVal={(d) => { setTranslationValue('name', item.code, d) }} width1='92' width2='404' />
                <EditCtrl Capt={localestr('Опис')} title={localestr('Зробіть опис страви максимально смачним, щоб гість замовив цю страву недочитавши першого речення!')}
                  Value={wndData?.translations?.[item.code]?.description || ""} typeVal={'longtext'} setVal={(d) => { setTranslationValue('description', item.code, d) }} width1='45' width2='496' height2='115' />
              </div>
            </div>
          ) : null
        )}
        {modifiers_cont ? modifiers_cont : null}
        {fld_goods_mod_btn}
        <div className='no-print' style={{ margin: '0', minWidth: '337px', display: 'flex', justifyContent: 'center', flexGrow: '100000' }}>
          <div style={{ margin: '2px 0', display: 'inherit', textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}
            onClick={() => { tabNew('catMenuGrp_list', localestr('Категорії меню')) }}>
            {localestr('Не забудьте зробити переклад категорій меню')}</div>
        </div>
        <div className='no-print' style={{ margin: '0', minWidth: '337px', display: 'flex', justifyContent: 'center', flexGrow: '100000' }}>
          <div style={{ width: '250px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'}
            onClick={() => generateTranslations()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>
              {localestr('Згенерувати автопереклад')}</div></div>
        </div>
      </Panel>
    }

    const labelData = [
      { name: localestr('Хіт'), action: () => setValue('label', 1) },
      { name: localestr('Веган'), action: () => setValue('label', 2) },
      { name: localestr('Акція'), action: () => setValue('label', 3) },
      { name: localestr('Новинка'), action: () => setValue('label', 4) },
      { name: localestr('Гостре'), action: () => setValue('label', 5) },
      { name: localestr('Від шефа'), action: () => setValue('label', 6) },
      { name: localestr('Пісне'), action: () => setValue('label', 7) },
      { name: localestr('Швидко'), action: () => setValue('label', 8) },
      { name: localestr('Очистити'), action: () => setValue('label', null) },
      //{name:localestr('Перенумерувати пакет'),icon:'#hisBut',action:()=>{}},
      //{name:localestr('Перейти в офлайн'),icon:'#hisBut',action:()=>{}},
    ]
    let aiBtn = null
    if (gemi) aiBtn = <div style={{ width: '175px', display: 'inline-block', verticalAlign: 'bottom', margin: 0 }} className={'key_btn'} onClick={() => { aiGoodsContent() }}><div style={{ height: '27px', lineHeight: '27px', display: 'block' }}>{localestr('Заповнити з ШІ (тест)')}</div></div>
    guest_cont = <Panel caption={localestr('Онлайн меню')} width={window.innerWidth < 768 ? 250 : 792} open={wndData.p_omenu === undefined ? true : wndData.p_omenu} setOpen={d => setWndData({ ...wndData, p_omenu: d })}>
      <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap' }}>
        <EditImg Capt={localestr('Велика картинка') + ' (800x600)'} Value={wndData.big_img || empty_img} setVal={(d) => { setValue('big_img', d) }} width1='72' width2='212' height2='159' img_width={800} img_height={600} img_transp={false} />
        <div style={{ minWidth: '12px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <div style={{ margin: '0', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', width: `${window.innerWidth < 768 ? 250 : '492px'}`, maxWidth: '1300px', flexGrow: 492 }}>
          <div style={{ margin: '0', display: 'flex', flexWrap: 'wrap', gap: '10px', flexDirection: 'row', /*width: '492px',*/ maxWidth: '1300px', flexGrow: 492 }}>
            <EditCtrl Capt={localestr('Категорія')} title={localestr('Категорія або підгрупа онлайн меню. Наприклад "Гарячі напої", "Перші страви", "Закуски"')}
              Value={wndData.menu_cat} typeVal={'catMenuGrp'} setVal={(d) => { setValue('menu_cat', d) }} width1='70' width2='299' />
            <div style={{ minWidth: '12px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
            <div style={{ minWidth: '73px', display: 'inline-block', flexGrow: 1.7 }}>{localestr('Позначка')}</div>
            <div style={{ width: '55px', display: 'inline-block', flexGrow: 1.7, position: 'relative' }}>
              <Menu stl={{ height: 'unset', position: 'absolute', width: 'calc(100% - 18px)' }} data={labelData} left={true}>
                <img style={{ width: '55px', height: '24px' }} src={wndData.label ? labels + '#label' + wndData.label : null} alt='' />
              </Menu></div>
            {aiBtn}
            <div style={{ minWidth: '1px', display: 'inline-block', flexGrow: 4, maxWidth: '300px' }}></div>
          </div>
          <EditCtrl Capt={localestr('Опис')} title={localestr('Зробіть опис страви максимально смачним, щоб гість замовив цю страву недочитавши першого речення!')}
            Value={wndData.description} typeVal={'longtext'} setVal={(d) => { setValue('description', d) }} width1='45' width2='496' height2='115' />
        </div>
      </div>
      {langs_cont ? langs_cont : null}
    </Panel>
  }

  let menuCont = null
  let modCont = null
  //const [currMod, setCurrMod] = useState(null);
  if (parseInt(wndData.is_menu)) {
    const modSorting = (a, b) => { //сортування модифікаторів 
      if (a.sorting < b.sorting) return -1
      if (a.sorting > b.sorting) return 1
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    }

    //const hModDragStart = (e, el) => {setCurrMod(el)}
    const hModDragStart = (e, el) => { dragRef.current = el; }
    const hModDragLeave = (e) => { e.target.style.background = ''; }
    const hModDragEnter = (e) => { e.target.style.background = '#92929233'; }
    const hModDragOver = (e) => {
      e.preventDefault();
      e.target.style.background = '#92929233';
    }
    const hModDrop = (e, el) => {
      e.preventDefault();
      e.target.style.background = '';
      const modifiers_new = [...wndData.modifiers || []].sort(modSorting)
      if (dragRef.current?.inGroup) {
        for (let i = 0; i < modifiers_new.length; i++) {
          let child = [...modifiers_new[i].child || []].sort(modSorting)
          const idx1 = child.findIndex(it => it.uid === dragRef.current?.uid)
          if (idx1 !== -1) {
            const idx2 = child.findIndex(it => it.uid === el.uid)
            if (idx2 !== -1) {
              const [it] = child.splice(idx1, 1)
              child.splice(idx2, 0, it)
              for (let k = 0; k < child.length; k++) child[k].sorting = k
              modifiers_new[i].child = child
              modifiers_new[i].edit = true
              setValue('modifiers', modifiers_new)
            }
            break
          }
        }
      }
      else {
        const idx1 = modifiers_new.findIndex(it => it.uid === dragRef.current?.uid)
        if (idx1 !== -1) {
          const idx2 = modifiers_new.findIndex(it => it.uid === el.uid)
          if (idx2 !== -1) {
            const [it] = modifiers_new.splice(idx1, 1)
            modifiers_new.splice(idx2, 0, it)
            for (let k = 0; k < modifiers_new.length; k++) {
              modifiers_new[k].sorting = k
              modifiers_new[k].edit = true
            }
            setValue('modifiers', modifiers_new)
          }
        }
      }
      /*let modData = wndData.modifiers.map(item => {
          console.log(item, el, currMod);
          if (item?.child?.length > 0 && currMod?.inGroup) {
              let modChild = item.child.map(item2 => {
                  if (item2.id === el.id && el?.inGroup === currMod?.inGroup) return {...item2, sorting: currMod.sorting, edit: true};
                  if (item2.id === currMod.id && el?.inGroup === currMod?.inGroup) return {...item2, sorting: el.sorting, edit: true};
                  return item2;
              })
              item = {...item, child: modChild};
          }
          else {
              if (item.id === el.id && el?.inGroup === currMod?.inGroup) return {...item, sorting: currMod.sorting, edit: true};
              if (item.id === currMod.id && el?.inGroup === currMod?.inGroup) return {...item, sorting: el.sorting, edit: true};
          }
          return item;
      });
      setValue('modifiers',modData)*/
    }

    let tmpData = []
    if (wndData.modifiers) tmpData = [...wndData.modifiers].filter(el => el.hide !== true)

    tmpData.sort(modSorting)

    modCont = tmpData.map((grp, i) => {
      let modItems = null
      let chlData = []
      if (grp.child) chlData = [...grp.child].filter(el => el.hide !== true)
      chlData.sort(modSorting)
      if (grp.type < 2) {
        modItems = chlData.map((el, k) => {
          let price = null
          if (el.price > 0) price = <div>{localestr('ціна ') + '+' + el.price}</div>
          else if (el.price < 0) price = <div>{localestr('ціна ') + el.price}</div>
          return (<div key={i + 'id' + k} draggable
            onDragStart={(e) => hModDragStart(e, { ...el, inGroup: true })}
            onDragLeave={(e) => hModDragLeave(e)}
            onDragEnter={(e) => hModDragEnter(e)}
            onDragOver={(e) => hModDragOver(e)}
            onDrop={(e) => hModDrop(e, { ...el, inGroup: true })}
            style={{ paddingLeft: '20px', fontStyle: 'italic', display: 'flex' }}>
            <div style={{ flexGrow: '200' }}><input id={i + 'id' + k} type={grp.type ? 'radio' : 'checkbox'} checked={el.type === 2 ? 0 : 1} onChange={() => { modCheckItem(grp, el) }} />
              <label htmlFor={i + 'id' + k} style={{ cursor: 'grab' }}>{el.name}</label></div>{price}
            <div style={{ paddingLeft: '10px' }}><img style={{ width: '16px', height: '16px' }} src={icon + '#catArts'} alt={''} onClick={() => { modItemEdit(grp, el) }} />
              <img style={{ width: '16px', height: '16px', marginLeft: '8px' }} src={icon + '#dlt'} alt={''} onClick={() => { msg(localestr('Ви дійсно бажаєте видалити модифікатор?'), null, [{ caption: 'OK', action: () => { modDelItem(grp, el) } }, { caption: localestr('Відмінити'), action: () => { } }]) }} /></div>
          </div>)
        }
        )
        return (<div key={i} style={{ border: '1px solid #0008', borderRadius: '5px', marginTop: '3px' }}>
          <div style={{ background: '#0001', display: 'flex', height: '24px' }}><div style={{ paddingLeft: '2px', flexGrow: '200' }}>{grp.name}</div><div style={{ paddingLeft: '10px' }}><img style={{ width: '16px', height: '16px' }} src={icon + '#catArts'} alt={''} onClick={() => { modGroupEdit(grp) }} />
            <img style={{ width: '16px', height: '16px', marginLeft: '8px' }} src={icon + '#dlt'} alt={''} onClick={() => { msg(localestr('Ви дійсно бажаєте видалити групу модифікаторів?'), null, [{ caption: 'OK', action: () => { modDelItem(grp) } }, { caption: localestr('Відмінити'), action: () => { } }]) }} /></div></div>{modItems}
          <div className='no-print' style={{ margin: '0', minWidth: '337px', display: 'flex', justifyContent: 'center', flexGrow: '100000' }}>
            <div style={{ width: '190px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { modItemEdit(grp, null) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Новий модифікатор')}</div></div>
          </div>
        </div>
        )
      }
      else {
        let price = null
        if (grp.price > 0) price = <div>{localestr('ціна ') + '+' + grp.price}</div>
        else if (grp.price < 0) price = <div>{localestr('ціна ') + grp.price}</div>
        return (
          <div key={i} draggable
            onDragStart={(e) => hModDragStart(e, { ...grp, inGroup: false })}
            onDragLeave={(e) => hModDragLeave(e)}
            onDragEnter={(e) => hModDragEnter(e)}
            onDragOver={(e) => hModDragOver(e)}
            onDrop={(e) => hModDrop(e, { ...grp, inGroup: false })}
            style={{ paddingLeft: '20px', fontStyle: 'italic', display: 'flex' }}>
            <div style={{ flexGrow: '200' }}><input id={i} type='checkbox' checked={grp.type === 4 ? 0 : 1} onChange={() => { modCheckItem(null, grp) }} />
              <label htmlFor={i} style={{ cursor: 'grab' }}>{grp.name}</label></div>{price}
            <div style={{ paddingLeft: '10px' }}><img style={{ width: '16px', height: '16px' }} src={icon + '#catArts'} alt={''} onClick={() => { modItemEdit(null, grp) }} />
              <img style={{ width: '16px', height: '16px', marginLeft: '8px' }} src={icon + '#dlt'} alt={''} onClick={() => { msg(localestr('Ви дійсно бажаєте видалити модифікатор?'), null, [{ caption: 'OK', action: () => { modDelItem(null, grp) } }, { caption: localestr('Відмінити'), action: () => { } }]) }} /></div></div>
        )
      }
    })

    const modGroupEdit = (grp) => {
      let cont = <FldModifiers data={grp} action={data => { if (Object.keys(data).length) modSaveItem(data) }} />
      newTWnd(cont, localestr('Група модифікаторів'))
    }

    const modItemEdit = (grp, itm) => {
      let cont = <CatModifiers group={grp} data={itm} goodName={wndData.menu_name} action={(grp, data) => { if (Object.keys(data).length) modSaveItem(grp, data) }} />
      newTWnd(cont, localestr('Модифікатор'))
    }

    const modItemEdit4 = (grp, itm) => {
      let cont = <CatModifiers group={grp} data={itm} type={4} goodName={wndData.menu_name} action={(grp, data) => { if (Object.keys(data).length) modSaveItem(grp, data) }} />
      newTWnd(cont, localestr('Модифікатор'))
    }

    //Збереження модифікатора: якщо передана лише група - зберігаємо її, інакше зберігаємо лише елемент. нові додаємо в кінець
    const modSaveItem = (grp, itm) => {
      let newModifiers = []
      if (wndData.modifiers) newModifiers = [...wndData.modifiers]
      let grpIdx = -1
      if (grp) grpIdx = newModifiers.findIndex(el => el.uid === grp.uid)
      if (itm && grpIdx !== -1) {
        let itmIdx = -1
        if (newModifiers[grpIdx].child) itmIdx = newModifiers[grpIdx].child.findIndex(el => el.uid === itm.uid)
        if (itmIdx !== -1) {
          const newItem = { ...newModifiers[grpIdx].child[itmIdx], ...itm }
          newModifiers[grpIdx].child[itmIdx] = newItem
        } else {
          if (!newModifiers[grpIdx].child) newModifiers[grpIdx].child = []
          const newItem = { ...itm, sorting: (newModifiers[grpIdx].child || []).length }
          newModifiers[grpIdx].child.push(newItem)
        }
      }
      else if (itm && itm.type > 3) {
        grpIdx = newModifiers.findIndex(el => el.uid === itm.uid)
        if (grpIdx !== -1) {
          const newItem = { ...newModifiers[grpIdx], ...itm }
          newModifiers[grpIdx] = newItem
        } else {
          const newItem = { ...itm, sorting: newModifiers.length }
          newModifiers.push(newItem)
        }
      }
      else if (grp) {
        if (grpIdx !== -1) {
          const newItem = { ...newModifiers[grpIdx], ...grp }
          newModifiers[grpIdx] = newItem
        } else {
          const newItem = { ...grp, sorting: newModifiers.length }
          newModifiers.push(newItem)
        }
      }
      let newData = { ...wndData, modifiers: newModifiers, changed: true }
      setWndData(newData, true)
    }

    //видалення: помічаємо елемент і перенумеровуємо всі після нього
    const modDelItem = (grp, itm) => {
      let newModifiers = []
      if (wndData.modifiers) newModifiers = [...wndData.modifiers]
      let grpIdx = -1
      if (grp) grpIdx = newModifiers.findIndex(el => el.uid === grp.uid)
      if (itm && grpIdx !== -1) {
        let itmIdx = -1
        if (newModifiers[grpIdx].child) itmIdx = newModifiers[grpIdx].child.findIndex(el => el.uid === itm.uid)
        if (itmIdx !== -1) {
          newModifiers[grpIdx].child[itmIdx].hide = true
          for (let i = itmIdx + 1; i < newModifiers[grpIdx].child[itmIdx].length; i++) {
            newModifiers[grpIdx].child[i].sorting--
            newModifiers[grpIdx].child[i].edit = true
          }
        }
      }
      else if (itm && itm.type > 3) {
        grpIdx = newModifiers.findIndex(el => el.uid === itm.uid)
        if (grpIdx !== -1) {
          newModifiers[grpIdx].hide = true
          for (let i = grpIdx + 1; i < newModifiers[grpIdx].length; i++) {
            newModifiers[i].sorting--
            newModifiers[i].edit = true
          }
        }
      }
      else if (grp) {
        if (grpIdx !== -1) {
          newModifiers[grpIdx].hide = true
          for (let i = grpIdx + 1; i < newModifiers[grpIdx].length; i++) {
            newModifiers[i].sorting--
            newModifiers[i].edit = true
          }
        }
      }
      let newData = { ...wndData, modifiers: newModifiers, changed: true }
      setWndData(newData, true)
    }

    //Позначки
    const modCheckItem = (grp, itm) => {
      let newModifiers = []
      if (wndData.modifiers) newModifiers = [...wndData.modifiers]
      let grpIdx = -1
      if (grp) grpIdx = newModifiers.findIndex(el => el.uid === grp.uid)
      if (itm && grpIdx !== -1) {
        let itmIdx = -1
        if (newModifiers[grpIdx].child) itmIdx = newModifiers[grpIdx].child.findIndex(el => el.uid === itm.uid)
        if (itmIdx !== -1) {
          if (newModifiers[grpIdx].type === 1) { //переключатель
            for (let i = 0; i < newModifiers[grpIdx].child.length; i++) {
              if (i === itmIdx) newModifiers[grpIdx].child[i].type = 3
              else newModifiers[grpIdx].child[i].type = 2
              newModifiers[grpIdx].child[i].edit = true
            }
          } else {
            if (newModifiers[grpIdx].child[itmIdx].type === 2) newModifiers[grpIdx].child[itmIdx].type = 3
            else newModifiers[grpIdx].child[itmIdx].type = 2
            newModifiers[grpIdx].child[itmIdx].edit = true
          }
          let newData = { ...wndData, modifiers: newModifiers, changed: true }
          setWndData(newData, true)
        }
      } else if (itm && itm.type > 3) {
        grpIdx = newModifiers.findIndex(el => el.uid === itm.uid)
        if (newModifiers[grpIdx].type === 4) newModifiers[grpIdx].type = 5
        else newModifiers[grpIdx].type = 4
        newModifiers[grpIdx].edit = true
        let newData = { ...wndData, modifiers: newModifiers, changed: true }
        setWndData(newData, true)
      }

    }


    menuCont = <Panel caption={localestr('Меню')} width={window.innerWidth < 768 ? 200 : 792} height={window.innerWidth < 768 ? '5000px' : '1200px'} open={wndData.p_menu === undefined ? true : wndData.p_menu} setOpen={d => setWndData({ ...wndData, p_menu: d })}>
      <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap' }}>
        <EditCtrl Capt={localestr('Назва меню')} title={localestr('Назва яка відображаіться офіціанту, гостю, друкується в чеку')} Value={wndData.menu_name} typeVal={'text'} setVal={(d) => { setValue('menu_name', d) }} width1='92' width2={window.innerWidth < 768 ? 200 : 364} />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, lineHeight: '26px', maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Колір кнопки')} title={localestr('Колір кнопки меню у Front Office. Будьте оригінальним!')} Value={wndData.colour} typeVal={'color'} setVal={(d) => { setValue('colour', d) }} width1='100' width2='36' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, lineHeight: '26px', maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Номер сортування')} title={localestr('Задайте порядок кнопок меню у Front Office. Пронумеруйте страви і вони будуть відображатись у відповідному порядку')}
          Value={wndData.sort || 0} typeVal={'number'} setVal={(d) => { setValue('sort', d) }} width1='142' width2='38' />
      </div>
      <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap'}}>
        <EditImg Capt={localestr('Іконка для офіціанта') + ' (100x100)'} Value={wndData.small_img || empty_img} setVal={(d) => { setValue('small_img', d) }} width1='78' width2='90' height2='90' img_width={100} img_height={100} />
        <div style={{ minWidth: '4px', display: 'inline-block', flexGrow: 2, maxWidth: '8px' }}></div>
        <div style={{ margin: '0', display: 'inherit', flexDirection: 'column', width: '306px', maxWidth: '612px', flexGrow: 306 }}>
          <EditCtrl Capt={localestr('Місце приготування')}
            title={localestr('Підрозділ з якого списуються інгредієти. А ще місце де друкується замовлення на готування')}
            Value={wndData.department} typeVal={'catDepartments'} setVal={(d) => { setValue('department', d) }} width1='159' width2='151' />
          <EditCtrl Capt={localestr('Додатково друкувати')} title={localestr('Якщо одного роздрукованого замовлення на готування замало!')}
            Value={wndData.department2} typeVal={'catDepartments'} setVal={(d) => { setValue('department2', d) }} width1='164' width2='146' />
          <EditCtrl Capt={localestr('Фіскальний апарат')}
            title={localestr('Прив\'язати товар до ПРРО (ФОПа). Таким чином можна розділити, який товар куди має продаватись. Прив\'язувати товари до ПРРО можна цілими папками, не обов\'язково робити це для кожного одного товару!')}
            Value={wndData.fiscal} typeVal={'catDevices'} setVal={(d) => { setValue('fiscal', d) }} width1='159' width2='151' />
        </div>
        <div style={{ minWidth: '6px', display: 'flex', flexWrap: 'wrap', flexGrow: 3, maxWidth: '12px' }}></div>
        <div style={{ margin: '0', display: 'inherit', flexDirection: 'column', width: '308px', maxWidth: '616px', flexGrow: 308 }}>
          {fromCont}
          <EditCtrl Capt={localestr('Заборонити знижки')} title={localestr('При наданні знижки, на цей товар знижка діяти не буде. Буває корисно наприклад для алкоголю, щоб часом не продати нижче "МРЦ" і не заробити штраф!')}
            Value={wndData.disable_discount} typeVal={'l_check'} setVal={(d) => { setValue('disable_discount', d) }} width1='175' width2='20' />
          <EditCtrl Capt={localestr('Змінювати кількість після приготування')} title={localestr('Дає змогу офіціанту змінити кількість страви у замовленні вже після того як він натиснув кнопку Готувати. Використовуйте для вагових страв. на які не можливо передбачити точну кількість наперед. Наприклад "Риба на вагу"')}
            Value={wndData.gravimetric} typeVal={'l_check'} setVal={(d) => { setValue('gravimetric', d) }} width1='296' width2='20' />
          <EditCtrl Capt={localestr('Додати у QR меню (у закладі)')} title={localestr('Відмітьте якщо хочете, щоб страва відображалася у QR меню!')}
            Value={wndData.guest_enable} typeVal={'l_check'} setVal={(d) => { setValue('guest_enable', d) }} width1='175' width2='20' />
          <EditCtrl Capt={localestr('Додати у онлайн меню (доставка)')} title={localestr('Відмітьте якщо хочете, щоб страва відображалася у онлайн меню!')}
            Value={wndData.online_enable} typeVal={'l_check'} setVal={(d) => { setValue('online_enable', d) }} width1='175' width2='20' />
        </div>
      </div>

      <Panel caption={localestr('Калорії, алергени, пакування')} width={window.innerWidth < 768 ? 250 : 792} open={wndData.p_detal === undefined ? false : wndData.p_detal} setOpen={d => setWndData({ ...wndData, p_detal: d })}>
        <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap'}}>
          <EditCtrl Capt={localestr('Вага нетто порції')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
            Value={wndData.weight} typeVal={'text'} setVal={(d) => { setValue('weight', d) }} width1='130' width2='54' />
          <div style={{ minWidth: '16px', display: 'inline-block', flexGrow: 8, lineHeight: '26px', maxWidth: '32px' }}>{localestr('г')}</div>
          <EditCtrl Capt={localestr('Білки')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
            Value={wndData.proteins} typeVal={'text'} setVal={(d) => { setValue('proteins', d) }} width1='40' width2='48' />
          <div style={{ minWidth: '16px', display: 'inline-block', flexGrow: 8, lineHeight: '26px', maxWidth: '32px' }}>{localestr('г')}</div>
          <EditCtrl Capt={localestr('Жири')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
            Value={wndData.fat} typeVal={'text'} setVal={(d) => { setValue('fat', d) }} width1='42' width2='48' />
          <div style={{ minWidth: '16px', display: 'inline-block', flexGrow: 8, lineHeight: '26px', maxWidth: '32px' }}>{localestr('г')}</div>
          <EditCtrl Capt={localestr('Вуглеводи')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
            Value={wndData.carbohydrate} typeVal={'text'} setVal={(d) => { setValue('carbohydrate', d) }} width1='76' width2='46' />
          <div style={{ minWidth: '16px', display: 'inline-block', flexGrow: 8, lineHeight: '26px', maxWidth: '32px' }}>{localestr('г')}</div>
          <EditCtrl Capt={localestr('Енергетична цінність')} title={localestr('Використовується для друку технологічних карт, а також відображається готсю у онлайн меню')}
            Value={wndData.energy} typeVal={'text'} setVal={(d) => { setValue('energy', d) }} width1='160' width2='44' />
          <div style={{ minWidth: '36px', display: 'inline-block', flexGrow: 18, lineHeight: '26px', maxWidth: '72px' }}>{localestr('ккал')}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: '10px', height: '1px', background: '#00000044', marginRight: '5px', marginTop: '2px' }} />
          <div style={{ margin: '2px 0', display: 'inherit', fontWeight: '600' }}>{localestr('Алергени')}</div>
          <div style={{ width: '10px', height: '1px', background: '#00000044', marginLeft: '5px', marginTop: '2px', flexGrow: '10' }} />
        </div>

        <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap' }}>
          <div style={{ margin: '0', display: 'inherit', flexDirection: 'column', width: '200px', maxWidth: '404px', flexGrow: 200 }}>
            <EditCtrl Capt={localestr('глютен або його сліди')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
              Value={wndData && wndData.allergens && wndData.allergens.includes("GL") ? '1' : ''} typeVal={'l_check'} setVal={(d) => { setAllerg('GL', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('лактоза')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
              Value={wndData && wndData.allergens && wndData.allergens.includes("LAC") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('LAC', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('фруктоза')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
              Value={wndData && wndData.allergens && wndData.allergens.includes("FRU") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('FRU', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('злакові продукти')} title={localestr('Використовується для друку технологічних карт, а також відображається гостю у онлайн меню')}
              Value={wndData && wndData.allergens && wndData.allergens.includes("W") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('W', d) }} width1='165' width2='20' />
          </div>
          <div style={{ margin: '0', display: 'inherit', flexDirection: 'column', width: '200px', maxWidth: '404px', flexGrow: 200 }}>
            <EditCtrl Capt={localestr('ракоподібні продукти')} Value={wndData && wndData.allergens && wndData.allergens.includes("C") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('C', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('яйця')} Value={wndData && wndData.allergens && wndData.allergens.includes("E") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('E', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('риба')} Value={wndData && wndData.allergens && wndData.allergens.includes("F") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('F', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('арахіс')} Value={wndData && wndData.allergens && wndData.allergens.includes("PN") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('PN', d) }} width1='165' width2='20' />
          </div>
          <div style={{ margin: '0', display: 'inherit', flexDirection: 'column', width: '200px', maxWidth: '404px', flexGrow: 200 }}>
            <EditCtrl Capt={localestr('соєві боби')} Value={wndData && wndData.allergens && wndData.allergens.includes("S") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('S', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('молочні продукти')} Value={wndData && wndData.allergens && wndData.allergens.includes("M") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('M', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('горіхи')} Value={wndData && wndData.allergens && wndData.allergens.includes("N") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('N', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('селера')} Value={wndData && wndData.allergens && wndData.allergens.includes("CEL") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('CEL', d) }} width1='165' width2='20' />
          </div>
          <div style={{ margin: '0', display: 'inherit', flexDirection: 'column', width: '200px', maxWidth: '404px', flexGrow: 200 }}>
            <EditCtrl Capt={localestr('гірчиця')} Value={wndData && wndData.allergens && wndData.allergens.includes("MUS") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('MUS', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('кунжут')} Value={wndData && wndData.allergens && wndData.allergens.includes("SE") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('SE', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('люпін')} Value={wndData && wndData.allergens && wndData.allergens.includes("L") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('L', d) }} width1='165' width2='20' />
            <EditCtrl Capt={localestr('молюски')} Value={wndData && wndData.allergens && wndData.allergens.includes("MO") ? '1' : '0'} typeVal={'l_check'} setVal={(d) => { setAllerg('MO', d) }} width1='165' width2='20' />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <EditCtrl Capt={localestr('Пакування')} Value={wndData.package} typeVal={'catGoods'} setVal={(d) => { setValue('package', d) }} width1='80' width2='100' />
          <div style={{ minWidth: '140px', display: 'inline-block', flexGrow: 4, maxWidth: '320px', alignContent: 'center', fontSize: 'small', fontStyle: 'italic', color: '#00F' }}>{localestr('буде додаватись у замовлення на доставку, можна задати для цілої папки або для конкретної позиції')}</div>
        </div>
      </Panel>
      {guest_cont}
      <Panel caption={localestr('Модифікатори')} width={window.innerWidth < 768 ? 250 : 792} open={wndData.p_modif === undefined ? false : wndData.p_modif}
        setOpen={d => setWndData({ ...wndData, p_modif: d })} info={<div style={{ textAlign: 'justify', maxWidth: '350px', whiteSpace: 'normal' }}>
          <p>{localestr("Модифікатори — спеціальні елементи в Меню, які уточнюють блюдо: його вартість, склад, особливості приготування, побажання гостя.")}</p>
          <p>{localestr("За допомогою модифікаторів можна внести зміни в склад або процес приготування страви на касі, наприклад, вказати ступінь прожарювання м'яса, яким сиропом полити морозиво, тощо.")}</p>
          <p>{localestr("Модифікатори зазвичай об'єднують в групи.")}</p></div>}
        url={'https://cocktail.org.ua/wiki/modifiers.html'}>
        {modCont}
        <div className='no-print' style={{ margin: '10px 0 0 0', minWidth: '337px', display: 'flex', justifyContent: 'center', flexGrow: '100000' }}>
          <div style={{ width: '260px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { modGroupEdit() }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Нова група модифікаторів')}</div></div>
          <div style={{ width: '260px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { modItemEdit4() }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Новий одиночний модифікатор')}</div></div>
        </div>
      </Panel>
      {/*<Panel caption={localestr('Модифікатори')} width={337} open={wndData.p_modif===undefined?false:wndData.p_modif} setOpen={d=>setWndData({...wndData,p_modif:d})}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={()=>newItemMod()}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItemMod()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>removeItemMod()}
            onKeyUp={(e)=>{if(e.key === 'Enter') removeItemMod()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div style={{flexGrow:'10'}}></div>
        </div>
        <div style={{margin:'0',height:'calc(100% - 30px)',minHeight:(min_height+marg)+'px',marginBottom:'-'+marg+'px'}}>
        <UniTable haveHeader={true} colsArr={cols} data={list} currCol={{...wndData.currentColMod,edit}} sorting={null} filter={null} clickSort={sortList} clickHandle={(item)=>{setColMod(item)}} openHandle={editClickMod} keyHandle={anyKeyMod} saveHandle={saveValueMod} cancelHandle={cancelEditMod} isActive={isActive2&&isActive()}/>
        </div>
        </Panel>*/}
    </Panel>
  }

  const needFocus = (reset = true) => {   //Таблиця
    if (isActive() === false) return -1
    const glData = getGlData()
    const needFocus = glData.needFocus
    if (needFocus === undefined) return -1
    if (reset) setGlData({ needFocus: -1 })
    return needFocus
  }

  const setColCal = (currentCol) => {
    setisActive(true)
    if (edit) return
    if (wndData.curr_calc.currentCol) if (currentCol.uid === wndData.curr_calc.currentCol.uid) return
    //const list=wndData.list
    //const sorting=wndData.sorting
    let newData = { ...wndData, currentCol }
    newData.curr_calc.currentCol = currentCol
    setWndData(newData)
    setGlData({ needFocus: 0 })
  }

  const setValCal = (name, data) => {
    let currentCol = wndData.curr_calc.currentCol
    const old_qtt = parseFloat(currentCol.sum_qtt || 0)
    currentCol[name] = data
    if (name === 'good') {
      const sum_qtt = parseFloat(currentCol.sum_qtt || 1)
      let sum_netto = 0
      if (typeof currentCol.good.unit === 'string') currentCol.good.unit = selUnitType.find(el => el.value === currentCol.good.unit)
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 2 || parseInt(currentCol.good.unit.value) === 3) sum_netto = 1000 * sum_qtt
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 10) sum_netto = sum_qtt
      currentCol.type = selGoodType.find(x => parseInt(x.value) === parseInt(data.type))
      currentCol.unit = data.unit
      currentCol.sum_qtt = sum_qtt.toFixed(4)
      currentCol.sum_netto = sum_netto.toFixed(0)
      currentCol.sum_prc = parseFloat(currentCol.good.sum_in || 0)
    } else if (name === 'sum_qtt') {
      const sum_qtt = parseFloat(data || 0)
      let sum_netto = parseInt(currentCol.sum_netto || 0) / (old_qtt || 1) * sum_qtt
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 2 || parseInt(currentCol.good.unit.value) === 3) sum_netto = 1000 * sum_qtt
      if (currentCol.good.unit) if (parseInt(currentCol.good.unit.value) === 10) sum_netto = sum_qtt
      currentCol.sum_netto = sum_netto.toFixed(0)
    }
    let newData = { ...wndData, currentCol }
    newData.curr_calc.currentCol = currentCol
    setWndData(newData)
  }

  const saveValueCal = () => {
    let errmsg = ''
    const currCol = { ...wndData.curr_calc.currentCol, edit: true }
    const list = wndData.curr_calc.list || []
    if (!currCol) return
    if (!currCol.good) errmsg = localestr("Не заповнено товар")
    else {
      if (currCol.good.id === wndData.id) errmsg += localestr('Продукція не може включати сама себе')
      if (currCol.good.ingr && currCol.good.ingr.find(el => wndData.id && el.id === wndData.id)) errmsg += localestr('Цей товар не може бути використаний')
      let idx = list.findIndex(m => m.good && m.good.id === currCol.good.id && m.uid !== currCol.uid && !m.hide)
      if (idx !== -1) msg(localestr("Товар") + " " + currCol.good.name + " " + localestr("дублюється в рядку") + " " + (idx + 1), localestr('Попередження'), [{ caption: 'OK', action: () => { } }])
    }
    if (!currCol.sum_qtt) errmsg = localestr("Не заповнено кількість або суму")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      currCol.sum_qtt = parseFloat(currCol.sum_qtt).toFixed(4)
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData }
      newData.curr_calc.list = list
      let netto = 0
      list.forEach(item => { netto += item.hide ? 0 : parseInt(item.sum_netto || 0) })
      if (newData.curr_calc.netto !== netto) {
        newData.curr_calc.netto = netto
        if (!newData.curr_calc.edit) newData.curr_calc.edit = true
      }
      //if(!newData.curr_calc.is_new){newData.curr_calc.is_new=true;newData.curr_calc.id=null;newData.curr_calc.date=null}
      setWndData(newData)
      setEdit(false)
    }
  }

  const setValueCal = (name, data) => {
    setisActive(false)
    let newData = { ...wndData }
    if (!newData.curr_calc) newData.curr_calc = { edit: true }
    if (data === '') newData.curr_calc[name] = null
    else newData.curr_calc[name] = data
    if (!newData.curr_calc.edit) newData.curr_calc.edit = true
    //if(!newData.curr_calc.is_new){newData.curr_calc.is_new=true;newData.curr_calc.id=null;newData.curr_calc.date=null}
    setWndData(newData, true)
  }

  const newItemCal = () => {
    if (edit) return
    let currentCol = { id: '', uid: uid(),edit: true }
    const newData = { ...wndData }
    if (!newData.curr_calc) newData.curr_calc = { edit: true }
    if (!newData.curr_calc.list) newData.curr_calc.list = []
    const list = newData.curr_calc.list.concat(currentCol)
    newData.curr_calc.list = list
    newData.curr_calc.currentCol = currentCol
    //if(!newData.curr_calc.is_new){newData.curr_calc.is_new=true;newData.curr_calc.id=null;newData.curr_calc.date=null}
    setWndData(newData, true)
    setEdit(true)
  }

  const copyItemCal = () => {
    if (edit) return
    if (typeof wndData.curr_calc.currentCol === 'object') {
      let currentCol = { ...wndData.curr_calc.currentCol, uid: uid(),edit: true }
      delete currentCol.id
      const list = wndData.curr_calc.list.concat(currentCol)
      let newData = { ...wndData }
      newData.curr_calc.list = list
      newData.curr_calc.currentCol = currentCol
      //if(!newData.curr_calc.is_new){newData.curr_calc.is_new=true;newData.curr_calc.id=null;newData.curr_calc.date=null}
      setWndData(newData, true)
      setEdit(true)
    }
  }

  const editItemCal = () => {
    if (edit) return
    if (!wndData.curr_calc.currentCol) return
    //const currentCol={...wndData.curr_calc.currentCol}
    //currentCol.cancel={...wndData.currentCol}
    //setWndData({...wndData,currentCol})
    setEdit(true)
  }

  const editClickCal = () => {
    if (typeof wndData.curr_calc.currentCol === 'object') editItemCal()
  }
  const selectionClickCal = () => {
    let curVall = undefined
    if (wndData.curr_calc && wndData.curr_calc.currentCol) curVall = wndData.curr_calc.currentCol.good
    if (!curVall) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProcCal, undefined, undefined, 2)
    else if (curVall.parent) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProcCal, curVall, curVall.parent, 2)
    else addTWnd('Вибір', 'catGoods_list', selectionProcCal, curVall, undefined, 2)
  }

  const selectionProcCal = (e, qtt, sum) => {
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    if (e.id === wndData.id) { msg(localestr('Продукція не може включати сама себе'), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]); return }
    if (e.ingr && e.ingr.find(el => wndData.id && el.id === wndData.id)) { msg(localestr('Цей товар не може бути використаний'), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]); return }
    if (!qtt && parseInt(selectionType) > 0) { inputNumber(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProcCal(e, parseFloat(d || 0)) }); return }
    if (!qtt) qtt = 1
    let newData = actions.getWndData()//{...wndData}
    if (!newData.curr_calc) newData.curr_calc = { edit: true }
    if (!newData.curr_calc.list) newData.curr_calc.list = []
    let list = newData.curr_calc.list
    let el = list.find(m => m.good.id === e.id)
    if (!el) {
      let sum_netto = 0
      if (e.unit) if (parseInt(e.unit.value) === 2 || parseInt(e.unit.value) === 3) sum_netto = 1000 * qtt
      if (e.unit) if (parseInt(e.unit.value) === 10) sum_netto = qtt
      el = {
        uid: uid(),
        good: { ...e },
        type: selGoodType.find(x => parseInt(x.value) === parseInt(e.type)),
        unit: e.unit,
        sum_qtt: qtt.toFixed(4),
        sum_netto: sum_netto.toFixed(0),
        edit: true,
        sum_prc: parseFloat(e.sum_in || 0)
      }
      list.push(el)
    } else if (el.hide) {
      let sum_netto = 0
      if (e.unit) if (parseInt(e.unit.value) === 2 || parseInt(e.unit.value) === 3) sum_netto = 1000 * qtt
      if (e.unit) if (parseInt(e.unit.value) === 10) sum_netto = qtt
      const sum_qtt = qtt
      el.sum_qtt = sum_qtt.toFixed(4)
      el.sum_netto = sum_netto.toFixed(0)
      el.hide = false
      el.edit = true
      el.sum_prc = parseFloat(e.sum_in || 0)
    } else {
      const sum_qtt = parseFloat(el.sum_qtt || 0) + qtt
      let sum_netto = parseInt(el.sum_netto || 0) / parseFloat(el.sum_qtt || 1) * sum_qtt
      el.sum_qtt = sum_qtt.toFixed(4)
      el.sum_netto = sum_netto.toFixed(0)
      el.edit = true
    }
    newData.curr_calc.currentCol = { ...el }
    newData.curr_calc.list = list
    let netto = 0
    list.forEach(item => { netto += item.hide ? 0 : parseInt(item.sum_netto || 0) })
    if (newData.curr_calc.netto !== netto) { newData.curr_calc.netto = netto; newData.curr_calc.edit = true }
    //if (!newData.curr_calc.is_new) { newData.curr_calc.is_new = true; newData.curr_calc.id = null; newData.curr_calc.date = null }
    setWndData(newData, true)
  }

  const removeItemCal = () => {
    if (edit) return
    if (!wndData.curr_calc.currentCol) return
    const currCol = { ...wndData.curr_calc.currentCol, edit: true, hide: true }
    const list = wndData.curr_calc.list
    const idx = list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    list[idx] = currCol
    let curIdx = idx + 1
    let currentCol = undefined
    for (let i = curIdx; i < list.length; i++) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    if (!currentCol) for (let i = curIdx - 1; i > 0; i--) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    let newData = { ...wndData }
    newData.curr_calc.list = list
    newData.curr_calc.currentCol = currentCol
    let netto = 0
    list.forEach(item => { netto += item.hide ? 0 : parseInt(item.sum_netto || 0) })
    newData.curr_calc.netto = netto
    //if(!newData.curr_calc.is_new){newData.curr_calc.is_new=true;newData.curr_calc.id=null;newData.curr_calc.date=null}
    setWndData(newData)
  }

  const cancelEditCal = () => {
    setEdit(false)
    if (!wndData.curr_calc.currentCol.good && !wndData.curr_calc.currentCol.qtt) {
      const list = wndData.curr_calc.list.filter(el => el.uid !== wndData.curr_calc.currentCol.uid)
      let newData = { ...wndData }
      newData.curr_calc.list = list
      newData.curr_calc.currentCol = undefined
      setWndData(newData)
    }
    //setTimeout(()=>sortList(wndData.sorting.dataId,wndData.sorting.sort,wndData.list),25)
  }

  const doc_print = () => {
    if (!wndData.id) { msg(localestr('Дані не збережені'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (!wndData.curr_calc) { msg(localestr('Дані не збережені'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    if (!wndData.curr_calc.id) { msg(localestr('Дані не збережені'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
    let item = { ...wndData.curr_calc, good: { id: wndData.id, name: wndData.name, unit: wndData.unit, sum_out: wndData.sum_out }, type: 'docCalculation' }
    tabNew('docPrint', localestr('Калькуляція'), item)
  }

  const openCalc = (d) => {
    if (!d) return
    if (wndData.curr_calc && wndData.curr_calc.id === d) return
    let curr_calc = wndData.calc_list.find(el => el.id === d)
    //доповнити цінами і uid
    const catGoods = context.getData('catGoods')
    for (let i = 0; i < curr_calc.table.length; i++) {
      const good_id = curr_calc.table[i].good_id
      const idx = catGoods.findIndex((it) => it.id === good_id)
      curr_calc.table[i].uid = uid()
      if (idx !== -1) curr_calc.table[i].sum_prc = parseFloat(catGoods[idx].sum_in || 0)
      if (curr_calc.table[i].ingr) {
        curr_calc.table[i].sum_prc = 0
        for (let j = 0; j < curr_calc.table[i].ingr.length; j++) {
          const good_id = curr_calc.table[i].ingr[j].good
          const idx = catGoods.findIndex((it) => it.id === good_id)
          if (idx !== -1) curr_calc.table[i].sum_prc += parseFloat(catGoods[idx].sum_in || 0) * parseFloat(curr_calc.table[i].ingr[j].qtt || 0)
        }

      }

    }
    curr_calc.list = []
    if (curr_calc.table) curr_calc.list = curr_calc.table.map((item) => {
      const newItem = {
        uid: uid(),
        id: item.id,
        good: { id: item.good_id, name: item.good, parent: { id: item.good_pid }, obj_type: 'catGoods' },
        type: selGoodType.find(x => parseInt(x.value) === parseInt(item.type)),
        unit: selUnitType.find(x => x.value === item.unit),
        sum_qtt: item.qtt.toFixed(4),
        sum_netto: item.netto.toFixed(0),
        ingr: item.ingr,
        sum_prc: item.sum_prc
      }
      if (item.edit) newItem.edit = true
      return newItem
    })
    setWndData({ ...wndData, curr_calc }, true)
  }

  const saveDoc = (d, close = false, cnt = 0) => {
    const curr_calc = wndData.curr_calc
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (close) tabClose(false)
      else load('action=lstCalculatios&data=' + wndData.id, dt => loadCalculations(dt, d.data.id))
    } else {
      wndData = actions.getWndData()
      setWndData({ ...wndData, curr_calc })
      if (!wndData.id) {
        if (cnt > 2) return
        setTimeout(() => saveDoc(d, close, cnt + 1), 200)
        return
      }
      let data = {}
      if (curr_calc && curr_calc.edit) {
        if (curr_calc.id) data.id = curr_calc.id
        data.header = { author: curr_calc.author || context.user.id, date: curr_calc.date || (new Date()).toISOString(), good: { id: wndData.id }, qtt: curr_calc.qtt || 1, netto: curr_calc.netto, cooking: curr_calc.cooking, posted: curr_calc.posted }
        if (curr_calc.marked !== '1' && curr_calc.marked !== 1) data.header.act = 'post'
        if (!curr_calc.author) data.header.author = { id: 'NULL' }
      }
      let table = []
      if (curr_calc && curr_calc.list) table = curr_calc.list.filter(el => el.edit)
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (curr_calc.id) data.id = curr_calc.id
        if (curr_calc.marked !== '1' && curr_calc.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let d = { good: { id: el.good.id }, qtt: el.sum_qtt, netto: el.sum_netto }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }
      if (Object.keys(data).length && curr_calc && curr_calc.posted && parseInt(curr_calc.posted) > 0) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modCalculation&data=' + JSON.stringify(data), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Відмінити'), action: () => { loading = false } }
      ])
      else if (Object.keys(data).length && (!curr_calc.marked || parseInt(curr_calc.marked) === 0)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modCalculation&data=' + JSON.stringify(data), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modCalculation&data=' + JSON.stringify(data), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Відмінити'), action: () => { loading = false } }
      ])
      else if (curr_calc && (curr_calc.posted === '0' || curr_calc.posted === 0) && (curr_calc.marked !== '1' && curr_calc.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postCalculation&data=' + JSON.stringify(curr_calc), undefined, (dt) => { saveDoc(dt, close) }) } },
        { caption: localestr('Відмінити'), action: () => { loading = false } }
      ])
      else if (close) {
        loading = false
        setTimeout(() => tabClose(false), 100)
      }
    }
  }

  const openList = () => {
    if (!wndData.curr_calc) return
    if (!wndData.curr_calc.id) { msg(localestr("Поточну калькуляцію не збережено.\nСпочатку збережіть калькуляцію!"), localestr('Повідомлення'), [{ caption: 'OK', action: () => { } }]); return }
    const item = { currentCol: { ...wndData.curr_calc } }
    tabNew('docCalculation_list', localestr('Калькуляції'), item)
  }

  const copyCalc = (qst = true) => {
    if (wndData.curr_calc.edit && qst) {
      msg(localestr('Поточну калькуляцію не збережено. Продовжити?'), localestr('Повідомлення'), [{ caption: localestr('Так'), action: () => { copyCalc(false) } }, { caption: localestr('Ні'), action: () => { } }])
      return
    }
    const curr_calc = { ...wndData.curr_calc, date: (new Date()).toISOString().substring(0, 19) + 'Z', author: context.user, edit: true }
    delete curr_calc.id
    for (let i = 0; i < curr_calc.list.length; i++) { delete curr_calc.list[i].id; curr_calc.list[i].uid = uid(); curr_calc.list[i].edit = true }
    setWndData({ ...wndData, curr_calc }, true)
  }

  function getEAN13Checksum(code12) {
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      const digit = Number(code12[i]);
      sum += i % 2 === 0 ? digit : digit * 3;
    }

    return (10 - (sum % 10)) % 10;
  }

  const generateBarcode = () => {
    if (!wndData.id) {
      saveValue(false)
    }
    const zerosCount = 12 - 2 - wndData.id.length;
    let base = '20' + '0'.repeat(zerosCount) + wndData.id
    let code
    const checksum = getEAN13Checksum(base);

    code = base + String(checksum)

    setValue('barcode', code)
  }

  const openCalcEdit = (d) => {
    if (!d) {
      if (!wndData.curr_calc) return
      const curr_calc = wndData.curr_calc
      let data = {}
      if (curr_calc && curr_calc.edit) {
        if (curr_calc.id) data.id = curr_calc.id
        data.header = { author: curr_calc.author || context.user.id, date: curr_calc.date, good: { id: wndData.id }, qtt: curr_calc.qtt || 1, netto: curr_calc.netto, cooking: curr_calc.cooking, posted: curr_calc.posted }
        if (curr_calc.marked !== '1' && curr_calc.marked !== 1) data.header.act = 'post'
        if (!curr_calc.author) data.header.author = { id: 'NULL' }
      }
      let table = []
      if (curr_calc && curr_calc.list) table = curr_calc.list.filter(el => el.edit)
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (curr_calc.id) data.id = curr_calc.id
        if (curr_calc.marked !== '1' && curr_calc.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let d = { good: { id: el.good.id }, qtt: el.sum_qtt, netto: el.sum_netto }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }
      if (Object.keys(data).length && curr_calc && curr_calc.posted && parseInt(curr_calc.posted) > 0) {
        msg(localestr('Поточну калькуляцію не збережено. Зберегти?'), localestr('Збереження'), [
          { caption: localestr('Так'), action: () => { loaddata('action=modCalculation&data=' + JSON.stringify(data), undefined, (dt) => load('action=docCalculation&data=' + dt.data['id'], openCalcEdit)) } },
          { caption: localestr('Ні'), action: () => { wndData.currentCol['id'] ? load('action=docCalculation&data=' + wndData.currentCol['id'], openCalcEdit) : tabNew('docCalculation_edit', localestr('Калькуляція') + ' *', { date: (new Date()).toISOString().substring(0, 19) + 'Z', author: context.user, qtt: 1, edit: true, update: () => { load('action=lstCalculatios&data=' + wndData.id, dt => loadCalculations(dt, d.data.id)) } }) } }
        ])
        return
      }
      load('action=docCalculation&data=' + curr_calc.id, openCalcEdit)
    }
    else if (d) {
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      tabNew('docCalculation_edit', localestr('Калькуляція') + ' №' + toText(d.data['id']), { ...d.data, table: d.table, author: context.user, update: () => { load('action=lstCalculatios&data=' + wndData.id, dt => loadCalculations(dt, d.data.id)) } })
    }
  }

  const anyKeyCal = (key) => {
    if (key === 'Delete') removeItemCal()
    else if (key === 'Insert') newItemCal()
    else if (key === 'F9') copyItemCal()
    else if (key === 'Escape') cancelEditCal()
    //else if(key==='F2') filterCal()
  }

  const printTag = (printer) => {
    const prnData = { type: 9, printer: printer, data: [{ qtt_print: 1, id: wndData.id, name: wndData.menu_name || wndData.name, unit: wndData.unit?.name, barcode: wndData.barcode, price: wndData.sum_out }] }
    if (wndData.docType && parseInt(wndData.docType) === 1) {
      prnData.data.hall = localestr('Доставка')
      prnData.data.table = '~' + wndData.phone.substring(5)
    }
    loaddata('action=addJobs&data=' + encodeURIComponent(JSON.stringify(prnData)), undefined, () => { })
  }



  let calc = null
  let ttl_cost = 0
  let ttl_qtt = 1
  if (wndData.type === '2' || wndData.type === '3') {
    const curr_calc = wndData.curr_calc || {}

    const menuData = [
      { name: localestr('Друкована форма'), icon: '#b503', action: doc_print },
      { name: localestr('Відкрити в журналі'), icon: '#b220', action: openList },
      { name: localestr('Зберегти калькуляцію'), icon: '#b951', action: saveDoc },
      { name: localestr('Скопіювати калькуляцію'), icon: '#b952', action: copyCalc },
    ]

    if (wndData.calc_list) {
      menuData.push({ name: localestr('Список калькуляцій'), icon: '#b220', isFolder: true, id: 1 })
      wndData.calc_list.forEach(el => {
        menuData.push({ name: '№' + el.id + ' ' + localestr('від') + ' ' + toText(el.date), icon: '#docum' + (parseInt(el.marked) ? 'Del' : parseInt(el.posted) ? 'Pst' : ''), action: () => { openCalc(el.id) }, parent: 1 })
      })
    }

    const cols = [
      { caption: '№', minWidth: '20', maxWidth: '25', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: () => { saveValueCal() } },
      //{caption:'№',minWidth:'40',dataId:'id',sortable:true},
      { caption: localestr('Товар'), minWidth: '70', dataId: 'good', sortable: true, typeVal: 'catGoods', setFn: (d) => { setValCal('good', d) } },
      { caption: localestr('Тип'), minWidth: '70', maxWidth: '80', dataId: 'type', sortable: true },
      { caption: localestr('Од.'), minWidth: '30', maxWidth: '45', dataId: 'unit', sortable: true },
      { caption: localestr('К-сть'), minWidth: '40', maxWidth: '75', dataId: 'sum_qtt', sortable: true, typeVal: 'number4', setFn: (d) => { setValCal('sum_qtt', d) } },
      { caption: localestr('Нетто'), minWidth: '80', maxWidth: '110', dataId: 'sum_netto', sortable: true, typeVal: 'number0', setFn: (d) => { setValCal('sum_netto', d) } },
      { caption: localestr('Сума'), minWidth: '80', maxWidth: '110', dataId: 'sum_amount', sortable: true },
    ]

    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting

    let list = []
    let cnt_items = 0
    if (curr_calc.list) {
      ttl_qtt = curr_calc.qtt || 1
      list = curr_calc.list.map((item) => {
        const sum_amount = (item.sum_prc || 0) * parseFloat(item.sum_qtt || 0)
        const newItem = { ...item, sum_amount: sum_amount.toFixed(2) }
        if (!newItem.hide) { ttl_cost += sum_amount; cnt_items++ }
        return newItem
      })
    }
    const min_height = (cnt_items > 10 ? 11 : cnt_items + 1) * 33 + 7
    const marg = 3//edit?120:1
    calc = <Panel caption={localestr('Калькуляція')} width={window.innerWidth < 768 ? 250 : 792} open={wndData.p_calc === undefined ? true : wndData.p_calc} setOpen={d => setWndData({ ...wndData, p_calc: d })}>
      <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap' }}>
        <EditCtrl Capt={'№'} Value={curr_calc.id} typeVal={'text'} setVal={() => { }} width1='22' width2='42' disabled={true} />
        <div style={{ minWidth: '7px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('від')} Value={curr_calc.date ? new Date(curr_calc.date) : null} typeVal={'datetime'} setVal={(d) => { setValueCal('date', d) }} width1='22' width2='151' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('На кількість')} Value={curr_calc.qtt} typeVal={'number3'} setVal={(d) => { setValueCal('qtt', d) }} width1='88' width2='60' />
        <div style={{ width: '40px', display: 'inline-block', flexGrow: 1, maxWidth: '100px', lineHeight: '26px' }}>{toText(wndData.unit ? selUnitType.find(x => x.value === wndData.unit.value) : '')}</div>
        <EditCtrl Capt={localestr('вихід')} Value={curr_calc.netto} typeVal={'number0'} setVal={(d) => { setValueCal('netto', d) }} width1='40' width2='65' />
        <div style={{ width: '35px', display: 'inline-block', flexGrow: 1, maxWidth: '70px', lineHeight: '24px' }}>{localestr('грам')}</div>
      </div>

      <div className='toolBar no-print'>
        <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
          onClick={() => newItemCal()}
          onKeyUp={(e) => { if (e.key === 'Enter') newItemCal() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
        <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
          onClick={() => { copyItemCal() }} onKeyUp={(e) => { if (e.key === 'Enter') { copyItemCal() } }}
        ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
          onClick={() => removeItemCal()}
          onKeyUp={(e) => { if (e.key === 'Enter') removeItemCal() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

        <div tabIndex='0' className='toolBarSeparator'></div>

        <div tabIndex='0' onClick={() => { selectionClickCal() }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClickCal() }}
          style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
          <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
          {localestr('Підбір')}
        </div>
        <div style={{ flexGrow: '10', fontStyle: 'italic', padding: '0 5px', fontSize: 'small' }}>{localestr('Увага! Обмежений режим роботи з калькуляцією. Для повноцінної роботи ')}
          <div style={{ display: 'inline-block', color: '#00f', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => openCalcEdit()}>{localestr('натисніть сюди')}</div>.<br />
          <div style={{ display: 'inline-block', color: '#00f', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => { copyCalc() }}>{localestr('Скопіюйте')}</div>{localestr(' калькуляцію перед редагуванням, щоб зміни не впливали на попередні розрахунки.')}
        </div>
        <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
          <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
        </Menu></div>
      </div>
      <div style={{ margin: '0', height: 'calc(100% - 30px)', minHeight: (min_height + marg) + 'px', marginBottom: '-' + marg + 'px' }}>
        <UniTable haveHeader={true} colsArr={cols} data={list} currCol={{ ...curr_calc.currentCol, edit }} sorting={sorting} filter={curr_calc.filter} clickSort={sortList} clickHandle={(item) => { setColCal(item) }} openHandle={editClickCal} keyHandle={anyKeyCal} saveHandle={saveValueCal} cancelHandle={cancelEditCal} tblPos={tblPos} needFocus={needFocus} />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <div style={{ width: '260px', display: 'inline-block', flexGrow: 4, maxWidth: '260px' }}>{localestr('Загальна вартість набору')}</div>
        <div style={{ width: '20px', display: 'inline-block', flexGrow: 4, maxWidth: '20px', fontWeight: 'bold' }}>{ttl_cost.toFixed(2)}</div>
      </div>
      <EditCtrl Capt={localestr('Технологія приготування')} Value={curr_calc.cooking} typeVal={'longtext'} setVal={(d) => { setValueCal('cooking', d) }} width1='84' width2='496' />

    </Panel>
  }

  let sum_up = 0
  let sum_in = wndData.sum_in_mod || wndData.sum_in || ttl_cost || 0
  if (wndData.koef && parseFloat(wndData.koef)) sum_in = sum_in * parseFloat(wndData.koef)
  let sum_out = wndData.sum_out_mod || wndData.sum_out
  if (sum_out && sum_in) sum_up = ((sum_out - sum_in) * 100 / sum_in).toFixed(1)
  if (wndData.sum_up_mod) sum_up = wndData.sum_up_mod

  let cost_cont = null
  if (ttl_cost) cost_cont = <div style={{ width: '340px', display: 'inline-block', flexGrow: 4, color: '#00c' }}>{localestr('Розрахункова собівартість')} {(ttl_cost / ttl_qtt).toFixed(2)}</div>
  let without_cont = null
  if (parseInt(wndData.type) > 1) without_cont = <EditCtrl Capt={localestr('Не виготовляти при продажу')}
    title={localestr('Дає змогу при продажу страв не списувати інгредієнти, а брати з залишку готові вироби. Ця функія корисна коли є чіткий облік виробництва і передачі готових страв на реалізацію')}
    Value={'' + wndData.without_production} typeVal={'l_check'} setVal={(d) => { setValue('without_production', d) }} width1='220' width2='20' />
  let uktz_m = null
  if (parseInt(wndData?.excise?.value) || parseInt(wndData?.excise)) {
    let uktz_data = []
    if (parseInt(wndData.excise?.value) === 1 || parseInt(wndData.excise) === 1) uktz_data = [
      { name: '2208601100 горілка до 45,4% у посудинах до 2л.', icon: '#b402', action: () => { setValue('uktz', '2208601100') } },
      //{name:'2208601900 горілка до 45,4% у посудинах понад 2л.',icon:'#b402',action:()=>{setValue('uktz','2208601900')}},
      { name: '2208609100 горілка понад 45,4% у посудинах до 2л.', icon: '#b402', action: () => { setValue('uktz', '2208609100') } },
      //{name:'2208609900 горілка понад 45,4% у посудинах понад 2л.',icon:'#b402',action:()=>{setValue('uktz','2208609900')}},
      { name: '2208905400 текіла і настоянки у посудинах до 2л.', icon: '#b402', action: () => { setValue('uktz', '2208905400') } },
      { name: '2208501100 джин у посудинах до 2л.', icon: '#b402', action: () => { setValue('uktz', '2208501100') } },
      { name: '2208403100 ром і тафія у посудинах до 2л.', icon: '#b402', action: () => { setValue('uktz', '2208403100') } },
      { name: '2208308200 віскі інші у посудинах до 2л.', icon: '#b402', action: () => { setValue('uktz', '2208308200') } },
      { name: '2208701000 лікери у посудинах до 2л.', icon: '#b402', action: () => { setValue('uktz', '2208701000') } },
      { name: '2208906900 інші напої, що містять спирт (бальзам, коктейль...)', icon: '#b402', action: () => { setValue('uktz', '2208906900') } },
    ]
    else if (parseInt(wndData.excise?.value) === 2 || parseInt(wndData.excise) === 2) uktz_data = [
      { name: localestr('Ігристі вина'), icon: '#b220', isFolder: true, id: 1 },
      { name: '2204101100 шампанське', icon: '#b402', parent: 1, action: () => { setValue('uktz', '2204101100') } },
      { name: '2204101500 просеко', icon: '#b402', parent: 1, action: () => { setValue('uktz', '2204101500') } },
      { name: '2206008900 інші зброжені напої (фраголіно)', icon: '#b402', parent: 1, action: () => { setValue('uktz', '2206008900') } },
      { name: '2204109300 ігристі інші', icon: '#b402', parent: 1, action: () => { setValue('uktz', '2204109300') } },
      { name: '2204109600 інші сортові вина', icon: '#b402', parent: 1, action: () => { setValue('uktz', '2204109600') } },
      { name: '2204109800 інші вина', icon: '#b402', parent: 1, action: () => { setValue('uktz', '2204109800') } },
      { name: '2204291000 газовані вина у іншій тарі', icon: '#b402', parent: 1, action: () => { setValue('uktz', '2204291000') } },
      { name: localestr('Вина у посудинах до 2л.'), icon: '#b220', isFolder: true, id: 2 },
      //{name:'2204210800 інші сортові вина',icon:'#b402',parent:2,action:()=>{setValue('uktz','2204210800')}},
      { name: '2204212800 венето', icon: '#b402', parent: 2, action: () => { setValue('uktz', '2204212800') } },
      { name: '2204216600 тоскана', icon: '#b402', parent: 2, action: () => { setValue('uktz', '2204216600') } },
      { name: '2204218000 вина інші до 15% (марочні)', icon: '#b402', parent: 2, action: () => { setValue('uktz', '2204218000') } },
      { name: '2204218300 вина інші до 15% (білі)', icon: '#b402', parent: 2, action: () => { setValue('uktz', '2204218300') } },
      { name: '2204218400 вина інші до 15%', icon: '#b402', parent: 2, action: () => { setValue('uktz', '2204218400') } },
      { name: localestr('коньяки'), icon: '#b220', isFolder: true, id: 3 },
      { name: '2208201200 коньяк (cognac)', icon: '#b402', parent: 3, action: () => { setValue('uktz', '2208201200') } },
      { name: '2208201800 коньяк інший', icon: '#b402', parent: 3, action: () => { setValue('uktz', '2208201800') } },
      { name: '2208201900 коньяк інший', icon: '#b402', parent: 3, action: () => { setValue('uktz', '2208201900') } },
    ]
    else if (parseInt(wndData.excise?.value) === 3 || parseInt(wndData.excise) === 3) uktz_data = [
      { name: '2203000100 пиво пляшкове', icon: '#b402', action: () => { setValue('uktz', '2203000100') } },
      { name: '2203000900 пиво інше', icon: '#b402', action: () => { setValue('uktz', '2203000900') } },
      { name: '2203001000 пиво в тарі понад 10л.', icon: '#b402', action: () => { setValue('uktz', '2203001000') } },
    ]
    else if (parseInt(wndData.excise?.value) === -1 || parseInt(wndData.excise) === -1) uktz_data = [
      { name: '2402209020 сигарети з фільтром', icon: '#b402', action: () => { setValue('uktz', '2402209020') } },
      { name: '2402100010 сигари', icon: '#b402', action: () => { setValue('uktz', '2402100010') } },
      { name: '2403110000 тютюн для кальяна', icon: '#b402', action: () => { setValue('uktz', '2403110000') } },
    ]

    if (uktz_data.length) uktz_m = <Menu data={uktz_data}> <img className='toolBarIcon' src={icon + '#cat'} alt='' /></Menu>
  }

  const menuPrint = []
  if (catDevices) catDevices.forEach(el => {
    if (parseInt(el.device) < 4) menuPrint.push({ name: el.name, icon: '#b402', action: () => printTag({ ...el, type: el.device }) })
  })

  let print_btn = null
  if (wndData.barcode) print_btn = <div style={{ width: '90px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuPrint} left={true} bottom={true}>{localestr('Етикетка')}</Menu></div></div>

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', alignSelf: 'flex-start', flexGrow: '10000', height: `calc(100% - 8px)`, width: `calc(100% - ${window.innerWidth < 768 ? '30px' : '6px'} )` }}>
      <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap' }}>
        <EditCtrl Capt={localestr('Назва')}
          title={localestr('Назва товару або продукції')}
          Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='46' width2={window.innerWidth < 768 ? 200 : 350} />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Папка')}
          title={localestr('Папка або група в якій знаходиться товар')}
          Value={wndData.parent} typeVal={'fldGoods'} setVal={(d) => { setValue('parent', d) }} width1='46' width2='198' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Додати в меню')}
          title={localestr('Дає змогу офіціантам бачити та продавати цей товар у додатку Front Office')}
          Value={'' + wndData.is_menu} typeVal={'check'} setVal={(d) => { setValue('is_menu', d) }} width1='116' width2='20' />
      </div>
      <Panel caption={localestr('Товар')} width={window.innerWidth < 768 ? 250 : 792} open={wndData.p_good === undefined ? true : wndData.p_good} setOpen={d => setWndData({ ...wndData, p_good: d })}>
        <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap' }}>
          <EditIrg Capt={localestr('Ціна закупки')}
            title={localestr('Для продукції та напівфабрикатів немає сенсу заповняти. У продукції є собівартість, яка розраховується виходячи з вартості інгредієнтів')}
            Value={wndData.register_in || wndData.price_history} ValueHistory={wndData.price_history} typeVal={'irgGoods'} pid={wndData.id} setVal={setRegisterIn} width1='100' width2='90' />
          <div style={{ minWidth: '12px', display: 'inline-block', flexGrow: 5, maxWidth: '24px' }}></div>
          <EditIrg Capt={localestr('Ціна продажу')} Value={wndData.register_out || wndData.price_history_out} ValueHistory={wndData.price_history_out} typeVal={'irgMenu'} pid={wndData.id} setVal={setRegisterOut} width1='102' width2={window.innerWidth < 768 ? '65' : '90'} />
          <div style={{ width: '12px', display: 'inline-block', flexGrow: 5, maxWidth: '24px' }}></div>
          <EditCtrl Capt={localestr('Націнка')}
            title={localestr('Розраховуйте продажну ціну виходячи з потрібної націнки. Контролюйте Ваш дохід та прибуток')}
            Value={'' + sum_up} typeVal={'number'} setVal={(d) => { setValue('sum_up', d) }} width1='62' width2='70' />
          <div style={{ minWidth: '16px', display: 'inline-block', lineHeight: '26px', marginLeft: '2px', flexGrow: 250, maxWidth: '400px' }}>%</div>
          <div style={{ width: '10px', display: 'inline-block', flexGrow: 5, maxWidth: '20px' }}></div>
          <EditCtrl Capt={localestr('Акційна ціна')}
            title={localestr('Заповніть на період дії акції. У онлайн меню буде закреслена стара ціна і акційна нова ціна')}
            Value={wndData.special_price || 0} typeVal={'number'} setVal={(d) => { setValue('special_price', d) }} width1='94' width2='60' />
        </div>
        <div style={{ margin: '2px 0', display: 'inherit' }}>
          {cost_cont}{without_cont}
        </div>
        <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='16' width2='44' disabled={true} />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Вид')}
            title={localestr('Для продукції та напівфабрикатів треба створювати калькуляції, послуги ніколи не мають залишків, також є можливість контролювати акцизні марки')}
            Value={wndData.type} typeVal={'selGoodType'} setVal={(d) => { setValue('type', d) }} width1='35' width2='160' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Одиниця виміру')}
            title={localestr('В яких одиницях виміру рахувати залишки товару')}
            Value={wndData.unit} typeVal={'selUnitType'} setVal={(d) => { setValue('unit', d) }} width1='123' width2='55' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Штрихкод')}
            title={localestr('Заповніть якщо плануєте користуватись сканером штрихкодів. Дає можливість вводити товари в документи по штрихкоду')}
            Value={wndData.barcode} typeVal={'text'} setVal={(d) => { setValue('barcode', d) }} width1='77' width2='122' />
          <div style={{ width: '110px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => generateBarcode()}><div style={{ height: '27px', lineHeight: '27px', display: 'block' }}>Згенерувати</div></div>
        </div>
        <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap', }}>
          <EditCtrl Capt={localestr('Вид акцизу')}
            title={localestr('Підакцизні товари потрібно правильно поділити по групах. Це дасть змогу правильно подати звіт по акцизу.')}
            Value={wndData.excise} typeVal={'selExcise'} setVal={(d) => { setValue('excise', d) }} width1='84' width2='170' />
          <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Код УКТЗЕД')}
            title={localestr('Заповняється для підакцизних товарів')}
            Value={wndData.uktz} typeVal={'text'} setVal={(d) => { setValue('uktz', d) }} width1='92' width2='90' />
          {uktz_m}
          <div style={{ minWidth: '12px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
          <EditCtrl Capt={localestr('Звільнено від ПДВ')}
            title={localestr('Якщо заклад є платником ПДВ, а товар звільнений від ПДВ. Наприклад вигарети')}
            Value={'' + wndData.no_vat} typeVal={'check'} setVal={(d) => { setValue('no_vat', d) }} width1='130' width2='20' />
          <div style={{ minWidth: '12px', display: 'inline-block', flexGrow: 60, maxWidth: '160px' }}></div>
        </div>

      </Panel>
      {menuCont}
      {calc}
      {excise_block}
      <div className='no-print' style={{ margin: '10px 0 0 0', minWidth: '580px', maxWidth: '1160px', display: 'flex', justifyContent: 'center', flexGrow: '100000' }}>
        <div style={{ width: '60px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(true) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
        <div style={{ width: '90px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => { saveValue(false) }}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>{localestr('Зберегти')}</div></div>
        {print_btn}
      </div>
    </div>
  )

}

export default CatGoodsEdit